/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  ActiveCarTransportTruckDTO,
  AddressBasedRequest,
  AssignmentAddStandardizedCommentParams,
  AssignmentApproveSuggestionParams,
  AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentParams,
  AssignmentAutoApproveCheckDto,
  AssignmentCheckHotelNightConflictParams,
  AssignmentCreateStandardizedCommentParams,
  AssignmentDataLookupRecord,
  AssignmentDebugRunAutoAnalysisForFTDayParams,
  AssignmentDebugSeedGpsPositionsParams,
  AssignmentDeleteStandardizedCommentParams,
  AssignmentExecutePredefinedActionParams,
  AssignmentExtendedModel,
  AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentParams,
  AssignmentFindAssignmentByIDParams,
  AssignmentFindAssignmentByIDWithParamsParams,
  AssignmentFindMyAssignmentByIDWithParamsParams,
  AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateParams,
  AssignmentGeocodeAssignmentCoordinatesParams,
  AssignmentGetActiveAssignmentByCaseTypeAndRegNrParams,
  AssignmentGetActiveAssignmentsForUserParams,
  AssignmentGetAllLivePositionsParams,
  AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentParams,
  AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsParams,
  AssignmentGetAssignmentByIdParams,
  AssignmentGetAssignmentParams,
  AssignmentGetAssignmentRequestsParams,
  AssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodParams,
  AssignmentGetAssignmentsForMeAndTimePeriodParams,
  AssignmentGetAssignmentsForUserAndTimePeriodParams,
  AssignmentGetAssignmentsForUserParams,
  AssignmentGetAutoApproveAnalyticsParams,
  AssignmentGetAutoApproveBlockedAssignmentsParams,
  AssignmentGetAutoApproveCheckResultDetailsParams,
  AssignmentGetAutoApproveChecksForCaseParams,
  AssignmentGetAutoApproveQualityFlagsParams,
  AssignmentGetAutoApproveUnApprovalAnalyticsParams,
  AssignmentGetBookedAssignmentsForUserAndDateParams,
  AssignmentGetCarTransportTruckAssignmentsForAssignmentParams,
  AssignmentGetCarTransportTruckAssignmentsWithDetailsForDateParams,
  AssignmentGetCaseAssignmentPositionsForAssignmentParams,
  AssignmentGetDerivedEstimatedStartTimeParams,
  AssignmentGetFollowUpAssignmentCandidatesParams,
  AssignmentGetGpsPausesForUserAndDateParams,
  AssignmentGetHoursWorkedParams,
  AssignmentGetLastCaseAssignmentPositionForAssignmentParams,
  AssignmentGetLivePositionForAssignmentParams,
  AssignmentGetMaxFuelEstimateParams,
  AssignmentGetPlannedAssignmentsToSendToFieldTestersParams,
  AssignmentGetRideAlongCandidatesParams,
  AssignmentGetRideAlongLinksParams,
  AssignmentGetTransportAssignmentModelsForAssignmentParams,
  AssignmentGetUnassignedAssignmentByRegNrParams,
  AssignmentGetUnassignedFurtherTransportAssignmentByRegNrParams,
  AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaParams,
  AssignmentMarkAssignmentInNeedOfHandlingAsHandledParams,
  AssignmentModel,
  AssignmentOrAssignmentRequestDto,
  AssignmentRejectSuggestionParams,
  AssignmentRemoveStandardizedCommentParams,
  AssignmentReplacePlaceholderAssignmentParams,
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
  AssignmentSetAssignmentToFollowUpParams,
  AssignmentSortFieldTestersForNewAssignmentParams,
  AssignmentSyncSpeedLimitDataParams,
  AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentParams,
  AssignmentUpdateAssignmentParams,
  AssignmentUpdateAssignmentStatusParams,
  AssignmentUpdateStandardizedCommentParams,
  AssignmentViewModel,
  AssignmentViewModelBody,
  AssignmentViewModelSearchResult,
  AssignmentWithAutoApprovalCondition,
  AssignmentsToSendCountDto,
  AutoApprovalResponseDto,
  AutoApproveAnalyticsResult,
  AutoApproveQualityFlagsResult,
  AutoApproveResult,
  BlockedAssignmentDetail,
  CalculateFixedAssignmentTimeRequest,
  CalculateFixedAssignmentTimeResponse,
  CancelAssignmentRequest,
  CaseModel,
  ConnectedAssignmentsResponse,
  DayTransferValidationResult,
  DetailedStandardizedCommentDto,
  DeviationReportRequest,
  EventModel,
  ExtendedPosition,
  FindPlannedAssignmentsToSendToFieldTestersCountsRequest,
  FuelCostEstimateDto,
  GeoAndImageEnabledUpdateAssignmentRequest,
  GeoEnabledUpdateAssignmentRequest,
  GetAssignmentsRequest,
  GetBookedAssignmentsForUserAndDateList,
  GetFinishedAssignmentsRequest,
  GpsDayTrackWithPausesDto,
  HotelNightConflictDto,
  PlannedStopOverRequest,
  Position,
  ProximityBasedRequest,
  RideAlongCandidateDto,
  RideAlongLinksDto,
  SearchAssignmentsRequestBody,
  SendPlannedAssignmentsForUserRequest,
  SendPlannedAssignmentsForUserResult,
  SendPlannedAssignmentsToFieldTestersRequest,
  SortResult,
  StopOverRequest,
  StopOverRequestWithGeolocation,
  TransferAssignmentsRequest,
  TransferAssignmentsResult,
  TransportAssignmentModel,
  TransportAssignmentWithSegmentsModel,
  UnApprovalAnalyticsResult,
  UpdateAssignmentStatusRequest,
  ValidateUsersForDayTransferRequest,
  WorkedHours,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useAssignmentUpdateAssignmentHook = () => {
  const assignmentUpdateAssignment = useCustomInstance<void>();

  return useCallback(
    (
      assignmentViewModelBody: AssignmentViewModelBody,
      params?: AssignmentUpdateAssignmentParams
    ) => {
      return assignmentUpdateAssignment({
        url: `/api/Assignment/UpdateAssignment`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentViewModelBody,
        params,
      });
    },
    [assignmentUpdateAssignment]
  );
};

export const useAssignmentUpdateAssignmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentHook>>>,
    TError,
    {
      data: AssignmentViewModelBody;
      params?: AssignmentUpdateAssignmentParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentHook>>>,
  TError,
  { data: AssignmentViewModelBody; params?: AssignmentUpdateAssignmentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentUpdateAssignment = useAssignmentUpdateAssignmentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentHook>>>,
    { data: AssignmentViewModelBody; params?: AssignmentUpdateAssignmentParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return assignmentUpdateAssignment(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentUpdateAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentHook>>>
>;
export type AssignmentUpdateAssignmentMutationBody = AssignmentViewModelBody;
export type AssignmentUpdateAssignmentMutationError = unknown;

export const useAssignmentUpdateAssignment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentHook>>>,
    TError,
    {
      data: AssignmentViewModelBody;
      params?: AssignmentUpdateAssignmentParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentHook>>>,
  TError,
  { data: AssignmentViewModelBody; params?: AssignmentUpdateAssignmentParams },
  TContext
> => {
  const mutationOptions = useAssignmentUpdateAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentUpdateAssignmentWithGeolocationHook = () => {
  const assignmentUpdateAssignmentWithGeolocation = useCustomInstance<void>();

  return useCallback(
    (geoEnabledUpdateAssignmentRequest: GeoEnabledUpdateAssignmentRequest) => {
      return assignmentUpdateAssignmentWithGeolocation({
        url: `/api/Assignment/UpdateAssignmentWithGeolocation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: geoEnabledUpdateAssignmentRequest,
      });
    },
    [assignmentUpdateAssignmentWithGeolocation]
  );
};

export const useAssignmentUpdateAssignmentWithGeolocationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentUpdateAssignmentWithGeolocationHook>
      >
    >,
    TError,
    { data: GeoEnabledUpdateAssignmentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentUpdateAssignmentWithGeolocationHook>
    >
  >,
  TError,
  { data: GeoEnabledUpdateAssignmentRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentUpdateAssignmentWithGeolocation =
    useAssignmentUpdateAssignmentWithGeolocationHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentUpdateAssignmentWithGeolocationHook>
      >
    >,
    { data: GeoEnabledUpdateAssignmentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentUpdateAssignmentWithGeolocation(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentUpdateAssignmentWithGeolocationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentUpdateAssignmentWithGeolocationHook>
      >
    >
  >;
export type AssignmentUpdateAssignmentWithGeolocationMutationBody =
  GeoEnabledUpdateAssignmentRequest;
export type AssignmentUpdateAssignmentWithGeolocationMutationError = unknown;

export const useAssignmentUpdateAssignmentWithGeolocation = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentUpdateAssignmentWithGeolocationHook>
      >
    >,
    TError,
    { data: GeoEnabledUpdateAssignmentRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentUpdateAssignmentWithGeolocationHook>
    >
  >,
  TError,
  { data: GeoEnabledUpdateAssignmentRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentUpdateAssignmentWithGeolocationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentUpdateAssignmentWithGeolocationAndImageHook = () => {
  const assignmentUpdateAssignmentWithGeolocationAndImage =
    useCustomInstance<void>();

  return useCallback(
    (
      geoAndImageEnabledUpdateAssignmentRequest: GeoAndImageEnabledUpdateAssignmentRequest
    ) => {
      return assignmentUpdateAssignmentWithGeolocationAndImage({
        url: `/api/Assignment/UpdateAssignmentWithGeolocationAndImage`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: geoAndImageEnabledUpdateAssignmentRequest,
      });
    },
    [assignmentUpdateAssignmentWithGeolocationAndImage]
  );
};

export const useAssignmentUpdateAssignmentWithGeolocationAndImageMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentUpdateAssignmentWithGeolocationAndImageHook
          >
        >
      >,
      TError,
      { data: GeoAndImageEnabledUpdateAssignmentRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUpdateAssignmentWithGeolocationAndImageHook
        >
      >
    >,
    TError,
    { data: GeoAndImageEnabledUpdateAssignmentRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentUpdateAssignmentWithGeolocationAndImage =
      useAssignmentUpdateAssignmentWithGeolocationAndImageHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentUpdateAssignmentWithGeolocationAndImageHook
          >
        >
      >,
      { data: GeoAndImageEnabledUpdateAssignmentRequest }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentUpdateAssignmentWithGeolocationAndImage(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentUpdateAssignmentWithGeolocationAndImageMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUpdateAssignmentWithGeolocationAndImageHook
        >
      >
    >
  >;
export type AssignmentUpdateAssignmentWithGeolocationAndImageMutationBody =
  GeoAndImageEnabledUpdateAssignmentRequest;
export type AssignmentUpdateAssignmentWithGeolocationAndImageMutationError =
  unknown;

export const useAssignmentUpdateAssignmentWithGeolocationAndImage = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUpdateAssignmentWithGeolocationAndImageHook
        >
      >
    >,
    TError,
    { data: GeoAndImageEnabledUpdateAssignmentRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentUpdateAssignmentWithGeolocationAndImageHook
      >
    >
  >,
  TError,
  { data: GeoAndImageEnabledUpdateAssignmentRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentUpdateAssignmentWithGeolocationAndImageMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useAssignmentUpdateAssignmentStatusHook = () => {
  const assignmentUpdateAssignmentStatus = useCustomInstance<void>();

  return useCallback(
    (
      assignmentViewModelBody: AssignmentViewModelBody,
      params?: AssignmentUpdateAssignmentStatusParams
    ) => {
      return assignmentUpdateAssignmentStatus({
        url: `/api/Assignment/UpdateAssignmentStatus`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentViewModelBody,
        params,
      });
    },
    [assignmentUpdateAssignmentStatus]
  );
};

export const useAssignmentUpdateAssignmentStatusMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentStatusHook>>
    >,
    TError,
    {
      data: AssignmentViewModelBody;
      params?: AssignmentUpdateAssignmentStatusParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentStatusHook>>
  >,
  TError,
  {
    data: AssignmentViewModelBody;
    params?: AssignmentUpdateAssignmentStatusParams;
  },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentUpdateAssignmentStatus =
    useAssignmentUpdateAssignmentStatusHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentStatusHook>>
    >,
    {
      data: AssignmentViewModelBody;
      params?: AssignmentUpdateAssignmentStatusParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return assignmentUpdateAssignmentStatus(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentUpdateAssignmentStatusMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentStatusHook>>
  >
>;
export type AssignmentUpdateAssignmentStatusMutationBody =
  AssignmentViewModelBody;
export type AssignmentUpdateAssignmentStatusMutationError = unknown;

export const useAssignmentUpdateAssignmentStatus = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentStatusHook>>
    >,
    TError,
    {
      data: AssignmentViewModelBody;
      params?: AssignmentUpdateAssignmentStatusParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentUpdateAssignmentStatusHook>>
  >,
  TError,
  {
    data: AssignmentViewModelBody;
    params?: AssignmentUpdateAssignmentStatusParams;
  },
  TContext
> => {
  const mutationOptions =
    useAssignmentUpdateAssignmentStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentUpdateAssignmentStatusWithGeolocationHook = () => {
  const assignmentUpdateAssignmentStatusWithGeolocation =
    useCustomInstance<AssignmentViewModel>();

  return useCallback(
    (updateAssignmentStatusRequest: UpdateAssignmentStatusRequest) => {
      return assignmentUpdateAssignmentStatusWithGeolocation({
        url: `/api/Assignment/UpdateAssignmentStatusWithGeolocation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updateAssignmentStatusRequest,
      });
    },
    [assignmentUpdateAssignmentStatusWithGeolocation]
  );
};

export const useAssignmentUpdateAssignmentStatusWithGeolocationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentUpdateAssignmentStatusWithGeolocationHook
          >
        >
      >,
      TError,
      { data: UpdateAssignmentStatusRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUpdateAssignmentStatusWithGeolocationHook
        >
      >
    >,
    TError,
    { data: UpdateAssignmentStatusRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentUpdateAssignmentStatusWithGeolocation =
      useAssignmentUpdateAssignmentStatusWithGeolocationHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentUpdateAssignmentStatusWithGeolocationHook
          >
        >
      >,
      { data: UpdateAssignmentStatusRequest }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentUpdateAssignmentStatusWithGeolocation(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentUpdateAssignmentStatusWithGeolocationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUpdateAssignmentStatusWithGeolocationHook
        >
      >
    >
  >;
export type AssignmentUpdateAssignmentStatusWithGeolocationMutationBody =
  UpdateAssignmentStatusRequest;
export type AssignmentUpdateAssignmentStatusWithGeolocationMutationError =
  unknown;

export const useAssignmentUpdateAssignmentStatusWithGeolocation = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUpdateAssignmentStatusWithGeolocationHook
        >
      >
    >,
    TError,
    { data: UpdateAssignmentStatusRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentUpdateAssignmentStatusWithGeolocationHook>
    >
  >,
  TError,
  { data: UpdateAssignmentStatusRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentUpdateAssignmentStatusWithGeolocationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentCalculateFixedAssignmentTimeHook = () => {
  const assignmentCalculateFixedAssignmentTime =
    useCustomInstance<CalculateFixedAssignmentTimeResponse>();

  return useCallback(
    (
      calculateFixedAssignmentTimeRequest: CalculateFixedAssignmentTimeRequest
    ) => {
      return assignmentCalculateFixedAssignmentTime({
        url: `/api/Assignment/CalculateFixedAssignmentTime`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: calculateFixedAssignmentTimeRequest,
      });
    },
    [assignmentCalculateFixedAssignmentTime]
  );
};

export const useAssignmentCalculateFixedAssignmentTimeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentCalculateFixedAssignmentTimeHook>
      >
    >,
    TError,
    { data: CalculateFixedAssignmentTimeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentCalculateFixedAssignmentTimeHook>>
  >,
  TError,
  { data: CalculateFixedAssignmentTimeRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentCalculateFixedAssignmentTime =
    useAssignmentCalculateFixedAssignmentTimeHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentCalculateFixedAssignmentTimeHook>
      >
    >,
    { data: CalculateFixedAssignmentTimeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentCalculateFixedAssignmentTime(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentCalculateFixedAssignmentTimeMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentCalculateFixedAssignmentTimeHook>>
  >
>;
export type AssignmentCalculateFixedAssignmentTimeMutationBody =
  CalculateFixedAssignmentTimeRequest;
export type AssignmentCalculateFixedAssignmentTimeMutationError = unknown;

export const useAssignmentCalculateFixedAssignmentTime = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentCalculateFixedAssignmentTimeHook>
      >
    >,
    TError,
    { data: CalculateFixedAssignmentTimeRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentCalculateFixedAssignmentTimeHook>>
  >,
  TError,
  { data: CalculateFixedAssignmentTimeRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentCalculateFixedAssignmentTimeMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentSetAssignmentToStopOverHook = () => {
  const assignmentSetAssignmentToStopOver = useCustomInstance<CaseModel>();

  return useCallback(
    (stopOverRequest: StopOverRequest) => {
      return assignmentSetAssignmentToStopOver({
        url: `/api/Assignment/SetAssignmentToStopOver`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: stopOverRequest,
      });
    },
    [assignmentSetAssignmentToStopOver]
  );
};

export const useAssignmentSetAssignmentToStopOverMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSetAssignmentToStopOverHook>>
    >,
    TError,
    { data: StopOverRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSetAssignmentToStopOverHook>>
  >,
  TError,
  { data: StopOverRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSetAssignmentToStopOver =
    useAssignmentSetAssignmentToStopOverHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSetAssignmentToStopOverHook>>
    >,
    { data: StopOverRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentSetAssignmentToStopOver(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSetAssignmentToStopOverMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSetAssignmentToStopOverHook>>
  >
>;
export type AssignmentSetAssignmentToStopOverMutationBody = StopOverRequest;
export type AssignmentSetAssignmentToStopOverMutationError = unknown;

export const useAssignmentSetAssignmentToStopOver = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSetAssignmentToStopOverHook>>
    >,
    TError,
    { data: StopOverRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSetAssignmentToStopOverHook>>
  >,
  TError,
  { data: StopOverRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentSetAssignmentToStopOverMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentSetAssignmentToPlannedStopOverHook = () => {
  const assignmentSetAssignmentToPlannedStopOver =
    useCustomInstance<CaseModel>();

  return useCallback(
    (plannedStopOverRequest: PlannedStopOverRequest) => {
      return assignmentSetAssignmentToPlannedStopOver({
        url: `/api/Assignment/SetAssignmentToPlannedStopOver`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plannedStopOverRequest,
      });
    },
    [assignmentSetAssignmentToPlannedStopOver]
  );
};

export const useAssignmentSetAssignmentToPlannedStopOverMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSetAssignmentToPlannedStopOverHook>
      >
    >,
    TError,
    { data: PlannedStopOverRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSetAssignmentToPlannedStopOverHook>
    >
  >,
  TError,
  { data: PlannedStopOverRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSetAssignmentToPlannedStopOver =
    useAssignmentSetAssignmentToPlannedStopOverHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSetAssignmentToPlannedStopOverHook>
      >
    >,
    { data: PlannedStopOverRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentSetAssignmentToPlannedStopOver(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSetAssignmentToPlannedStopOverMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSetAssignmentToPlannedStopOverHook>
      >
    >
  >;
export type AssignmentSetAssignmentToPlannedStopOverMutationBody =
  PlannedStopOverRequest;
export type AssignmentSetAssignmentToPlannedStopOverMutationError = unknown;

export const useAssignmentSetAssignmentToPlannedStopOver = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSetAssignmentToPlannedStopOverHook>
      >
    >,
    TError,
    { data: PlannedStopOverRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSetAssignmentToPlannedStopOverHook>
    >
  >,
  TError,
  { data: PlannedStopOverRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentSetAssignmentToPlannedStopOverMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetMyEligibleStopoverAssignmentsHook = () => {
  const assignmentGetMyEligibleStopoverAssignments =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return assignmentGetMyEligibleStopoverAssignments({
        url: `/api/Assignment/GetMyEligibleStopoverAssignments`,
        method: 'GET',
        signal,
      });
    },
    [assignmentGetMyEligibleStopoverAssignments]
  );
};

export const getAssignmentGetMyEligibleStopoverAssignmentsQueryKey = () => {
  return [`/api/Assignment/GetMyEligibleStopoverAssignments`] as const;
};

export const useAssignmentGetMyEligibleStopoverAssignmentsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetMyEligibleStopoverAssignmentsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetMyEligibleStopoverAssignmentsHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetMyEligibleStopoverAssignmentsQueryKey();

  const assignmentGetMyEligibleStopoverAssignments =
    useAssignmentGetMyEligibleStopoverAssignmentsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetMyEligibleStopoverAssignmentsHook>
      >
    >
  > = ({ signal }) => assignmentGetMyEligibleStopoverAssignments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetMyEligibleStopoverAssignmentsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetMyEligibleStopoverAssignmentsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetMyEligibleStopoverAssignmentsHook>
    >
  >
>;
export type AssignmentGetMyEligibleStopoverAssignmentsQueryError = unknown;

export const useAssignmentGetMyEligibleStopoverAssignments = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetMyEligibleStopoverAssignmentsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetMyEligibleStopoverAssignmentsHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetMyEligibleStopoverAssignmentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetLivePositionForAssignmentHook = () => {
  const assignmentGetLivePositionForAssignment = useCustomInstance<Position>();

  return useCallback(
    (
      params?: AssignmentGetLivePositionForAssignmentParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetLivePositionForAssignment({
        url: `/api/Assignment/GetLivePositionForAssignment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetLivePositionForAssignment]
  );
};

export const getAssignmentGetLivePositionForAssignmentQueryKey = (
  params?: AssignmentGetLivePositionForAssignmentParams
) => {
  return [
    `/api/Assignment/GetLivePositionForAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetLivePositionForAssignmentQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetLivePositionForAssignmentHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetLivePositionForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetLivePositionForAssignmentHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetLivePositionForAssignmentQueryKey(params);

  const assignmentGetLivePositionForAssignment =
    useAssignmentGetLivePositionForAssignmentHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetLivePositionForAssignmentHook>
      >
    >
  > = ({ signal }) => assignmentGetLivePositionForAssignment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetLivePositionForAssignmentHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetLivePositionForAssignmentQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetLivePositionForAssignmentHook>>
  >
>;
export type AssignmentGetLivePositionForAssignmentQueryError = unknown;

export const useAssignmentGetLivePositionForAssignment = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetLivePositionForAssignmentHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetLivePositionForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetLivePositionForAssignmentHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetLivePositionForAssignmentQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetCaseAssignmentPositionsForAssignmentHook = () => {
  const assignmentGetCaseAssignmentPositionsForAssignment =
    useCustomInstance<ExtendedPosition[]>();

  return useCallback(
    (
      params?: AssignmentGetCaseAssignmentPositionsForAssignmentParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetCaseAssignmentPositionsForAssignment({
        url: `/api/Assignment/GetCaseAssignmentPositionsForAssignment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetCaseAssignmentPositionsForAssignment]
  );
};

export const getAssignmentGetCaseAssignmentPositionsForAssignmentQueryKey = (
  params?: AssignmentGetCaseAssignmentPositionsForAssignmentParams
) => {
  return [
    `/api/Assignment/GetCaseAssignmentPositionsForAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetCaseAssignmentPositionsForAssignmentQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetCaseAssignmentPositionsForAssignmentHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetCaseAssignmentPositionsForAssignmentParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetCaseAssignmentPositionsForAssignmentHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetCaseAssignmentPositionsForAssignmentQueryKey(params);

    const assignmentGetCaseAssignmentPositionsForAssignment =
      useAssignmentGetCaseAssignmentPositionsForAssignmentHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCaseAssignmentPositionsForAssignmentHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetCaseAssignmentPositionsForAssignment(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCaseAssignmentPositionsForAssignmentHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetCaseAssignmentPositionsForAssignmentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetCaseAssignmentPositionsForAssignmentHook
        >
      >
    >
  >;
export type AssignmentGetCaseAssignmentPositionsForAssignmentQueryError =
  unknown;

export const useAssignmentGetCaseAssignmentPositionsForAssignment = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetCaseAssignmentPositionsForAssignmentHook
      >
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetCaseAssignmentPositionsForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCaseAssignmentPositionsForAssignmentHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetCaseAssignmentPositionsForAssignmentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentSyncSpeedLimitDataHook = () => {
  const assignmentSyncSpeedLimitData = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentSyncSpeedLimitDataParams) => {
      return assignmentSyncSpeedLimitData({
        url: `/api/Assignment/SyncSpeedLimitData`,
        method: 'POST',
        params,
      });
    },
    [assignmentSyncSpeedLimitData]
  );
};

export const useAssignmentSyncSpeedLimitDataMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentSyncSpeedLimitDataHook>>>,
    TError,
    { params?: AssignmentSyncSpeedLimitDataParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentSyncSpeedLimitDataHook>>>,
  TError,
  { params?: AssignmentSyncSpeedLimitDataParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSyncSpeedLimitData = useAssignmentSyncSpeedLimitDataHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentSyncSpeedLimitDataHook>>>,
    { params?: AssignmentSyncSpeedLimitDataParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentSyncSpeedLimitData(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSyncSpeedLimitDataMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentSyncSpeedLimitDataHook>>>
>;

export type AssignmentSyncSpeedLimitDataMutationError = unknown;

export const useAssignmentSyncSpeedLimitData = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentSyncSpeedLimitDataHook>>>,
    TError,
    { params?: AssignmentSyncSpeedLimitDataParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentSyncSpeedLimitDataHook>>>,
  TError,
  { params?: AssignmentSyncSpeedLimitDataParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentSyncSpeedLimitDataMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetMaxFuelEstimateHook = () => {
  const assignmentGetMaxFuelEstimate = useCustomInstance<FuelCostEstimateDto>();

  return useCallback(
    (params?: AssignmentGetMaxFuelEstimateParams, signal?: AbortSignal) => {
      return assignmentGetMaxFuelEstimate({
        url: `/api/Assignment/GetMaxFuelEstimate`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetMaxFuelEstimate]
  );
};

export const getAssignmentGetMaxFuelEstimateQueryKey = (
  params?: AssignmentGetMaxFuelEstimateParams
) => {
  return [
    `/api/Assignment/GetMaxFuelEstimate`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetMaxFuelEstimateQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetMaxFuelEstimateHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetMaxFuelEstimateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetMaxFuelEstimateHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssignmentGetMaxFuelEstimateQueryKey(params);

  const assignmentGetMaxFuelEstimate = useAssignmentGetMaxFuelEstimateHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetMaxFuelEstimateHook>>>
  > = ({ signal }) => assignmentGetMaxFuelEstimate(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetMaxFuelEstimateHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetMaxFuelEstimateQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetMaxFuelEstimateHook>>>
>;
export type AssignmentGetMaxFuelEstimateQueryError = unknown;

export const useAssignmentGetMaxFuelEstimate = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetMaxFuelEstimateHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetMaxFuelEstimateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetMaxFuelEstimateHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetMaxFuelEstimateQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentCheckHotelNightConflictHook = () => {
  const assignmentCheckHotelNightConflict =
    useCustomInstance<HotelNightConflictDto>();

  return useCallback(
    (
      params?: AssignmentCheckHotelNightConflictParams,
      signal?: AbortSignal
    ) => {
      return assignmentCheckHotelNightConflict({
        url: `/api/Assignment/CheckHotelNightConflict`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentCheckHotelNightConflict]
  );
};

export const getAssignmentCheckHotelNightConflictQueryKey = (
  params?: AssignmentCheckHotelNightConflictParams
) => {
  return [
    `/api/Assignment/CheckHotelNightConflict`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentCheckHotelNightConflictQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentCheckHotelNightConflictHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentCheckHotelNightConflictParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentCheckHotelNightConflictHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentCheckHotelNightConflictQueryKey(params);

  const assignmentCheckHotelNightConflict =
    useAssignmentCheckHotelNightConflictHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentCheckHotelNightConflictHook>>
    >
  > = ({ signal }) => assignmentCheckHotelNightConflict(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentCheckHotelNightConflictHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentCheckHotelNightConflictQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentCheckHotelNightConflictHook>>
  >
>;
export type AssignmentCheckHotelNightConflictQueryError = unknown;

export const useAssignmentCheckHotelNightConflict = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentCheckHotelNightConflictHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentCheckHotelNightConflictParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentCheckHotelNightConflictHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentCheckHotelNightConflictQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGeocodeAssignmentCoordinatesHook = () => {
  const assignmentGeocodeAssignmentCoordinates =
    useCustomInstance<AssignmentViewModel>();

  return useCallback(
    (params?: AssignmentGeocodeAssignmentCoordinatesParams) => {
      return assignmentGeocodeAssignmentCoordinates({
        url: `/api/Assignment/GeocodeAssignmentCoordinates`,
        method: 'POST',
        params,
      });
    },
    [assignmentGeocodeAssignmentCoordinates]
  );
};

export const useAssignmentGeocodeAssignmentCoordinatesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGeocodeAssignmentCoordinatesHook>
      >
    >,
    TError,
    { params?: AssignmentGeocodeAssignmentCoordinatesParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGeocodeAssignmentCoordinatesHook>>
  >,
  TError,
  { params?: AssignmentGeocodeAssignmentCoordinatesParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGeocodeAssignmentCoordinates =
    useAssignmentGeocodeAssignmentCoordinatesHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGeocodeAssignmentCoordinatesHook>
      >
    >,
    { params?: AssignmentGeocodeAssignmentCoordinatesParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGeocodeAssignmentCoordinates(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGeocodeAssignmentCoordinatesMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGeocodeAssignmentCoordinatesHook>>
  >
>;

export type AssignmentGeocodeAssignmentCoordinatesMutationError = unknown;

export const useAssignmentGeocodeAssignmentCoordinates = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGeocodeAssignmentCoordinatesHook>
      >
    >,
    TError,
    { params?: AssignmentGeocodeAssignmentCoordinatesParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGeocodeAssignmentCoordinatesHook>>
  >,
  TError,
  { params?: AssignmentGeocodeAssignmentCoordinatesParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGeocodeAssignmentCoordinatesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetLastCaseAssignmentPositionForAssignmentHook =
  () => {
    const assignmentGetLastCaseAssignmentPositionForAssignment =
      useCustomInstance<ExtendedPosition>();

    return useCallback(
      (
        params?: AssignmentGetLastCaseAssignmentPositionForAssignmentParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetLastCaseAssignmentPositionForAssignment({
          url: `/api/Assignment/GetLastCaseAssignmentPositionForAssignment`,
          method: 'GET',
          params,
          signal,
        });
      },
      [assignmentGetLastCaseAssignmentPositionForAssignment]
    );
  };

export const getAssignmentGetLastCaseAssignmentPositionForAssignmentQueryKey = (
  params?: AssignmentGetLastCaseAssignmentPositionForAssignmentParams
) => {
  return [
    `/api/Assignment/GetLastCaseAssignmentPositionForAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetLastCaseAssignmentPositionForAssignmentQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetLastCaseAssignmentPositionForAssignmentHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetLastCaseAssignmentPositionForAssignmentParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetLastCaseAssignmentPositionForAssignmentHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetLastCaseAssignmentPositionForAssignmentQueryKey(params);

    const assignmentGetLastCaseAssignmentPositionForAssignment =
      useAssignmentGetLastCaseAssignmentPositionForAssignmentHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetLastCaseAssignmentPositionForAssignmentHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetLastCaseAssignmentPositionForAssignment(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetLastCaseAssignmentPositionForAssignmentHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetLastCaseAssignmentPositionForAssignmentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetLastCaseAssignmentPositionForAssignmentHook
        >
      >
    >
  >;
export type AssignmentGetLastCaseAssignmentPositionForAssignmentQueryError =
  unknown;

export const useAssignmentGetLastCaseAssignmentPositionForAssignment = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetLastCaseAssignmentPositionForAssignmentHook
      >
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetLastCaseAssignmentPositionForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetLastCaseAssignmentPositionForAssignmentHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetLastCaseAssignmentPositionForAssignmentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAllLivePositionsHook = () => {
  const assignmentGetAllLivePositions = useCustomInstance<ExtendedPosition[]>();

  return useCallback(
    (params?: AssignmentGetAllLivePositionsParams, signal?: AbortSignal) => {
      return assignmentGetAllLivePositions({
        url: `/api/Assignment/GetAllLivePositions`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAllLivePositions]
  );
};

export const getAssignmentGetAllLivePositionsQueryKey = (
  params?: AssignmentGetAllLivePositionsParams
) => {
  return [
    `/api/Assignment/GetAllLivePositions`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAllLivePositionsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAllLivePositionsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAllLivePositionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetAllLivePositionsHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssignmentGetAllLivePositionsQueryKey(params);

  const assignmentGetAllLivePositions = useAssignmentGetAllLivePositionsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetAllLivePositionsHook>>>
  > = ({ signal }) => assignmentGetAllLivePositions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAllLivePositionsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAllLivePositionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAllLivePositionsHook>>>
>;
export type AssignmentGetAllLivePositionsQueryError = unknown;

export const useAssignmentGetAllLivePositions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAllLivePositionsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAllLivePositionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetAllLivePositionsHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetAllLivePositionsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentSetAssignmentToStopOverWithGeolocationHook = () => {
  const assignmentSetAssignmentToStopOverWithGeolocation =
    useCustomInstance<void>();

  return useCallback(
    (stopOverRequestWithGeolocation: StopOverRequestWithGeolocation) => {
      return assignmentSetAssignmentToStopOverWithGeolocation({
        url: `/api/Assignment/SetAssignmentToStopOverWithGeolocation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: stopOverRequestWithGeolocation,
      });
    },
    [assignmentSetAssignmentToStopOverWithGeolocation]
  );
};

export const useAssignmentSetAssignmentToStopOverWithGeolocationMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentSetAssignmentToStopOverWithGeolocationHook
          >
        >
      >,
      TError,
      { data: StopOverRequestWithGeolocation },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentSetAssignmentToStopOverWithGeolocationHook
        >
      >
    >,
    TError,
    { data: StopOverRequestWithGeolocation },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentSetAssignmentToStopOverWithGeolocation =
      useAssignmentSetAssignmentToStopOverWithGeolocationHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentSetAssignmentToStopOverWithGeolocationHook
          >
        >
      >,
      { data: StopOverRequestWithGeolocation }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentSetAssignmentToStopOverWithGeolocation(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentSetAssignmentToStopOverWithGeolocationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentSetAssignmentToStopOverWithGeolocationHook
        >
      >
    >
  >;
export type AssignmentSetAssignmentToStopOverWithGeolocationMutationBody =
  StopOverRequestWithGeolocation;
export type AssignmentSetAssignmentToStopOverWithGeolocationMutationError =
  unknown;

export const useAssignmentSetAssignmentToStopOverWithGeolocation = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentSetAssignmentToStopOverWithGeolocationHook
        >
      >
    >,
    TError,
    { data: StopOverRequestWithGeolocation },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSetAssignmentToStopOverWithGeolocationHook>
    >
  >,
  TError,
  { data: StopOverRequestWithGeolocation },
  TContext
> => {
  const mutationOptions =
    useAssignmentSetAssignmentToStopOverWithGeolocationMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentApproveMultipleAssignmentsHook = () => {
  const assignmentApproveMultipleAssignments = useCustomInstance<string[]>();

  return useCallback(
    (assignmentViewModel: AssignmentViewModel[]) => {
      return assignmentApproveMultipleAssignments({
        url: `/api/Assignment/ApproveMultipleAssignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentViewModel,
      });
    },
    [assignmentApproveMultipleAssignments]
  );
};

export const useAssignmentApproveMultipleAssignmentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentApproveMultipleAssignmentsHook>>
    >,
    TError,
    { data: AssignmentViewModel[] },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentApproveMultipleAssignmentsHook>>
  >,
  TError,
  { data: AssignmentViewModel[] },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentApproveMultipleAssignments =
    useAssignmentApproveMultipleAssignmentsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentApproveMultipleAssignmentsHook>>
    >,
    { data: AssignmentViewModel[] }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentApproveMultipleAssignments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentApproveMultipleAssignmentsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentApproveMultipleAssignmentsHook>>
  >
>;
export type AssignmentApproveMultipleAssignmentsMutationBody =
  AssignmentViewModel[];
export type AssignmentApproveMultipleAssignmentsMutationError = unknown;

export const useAssignmentApproveMultipleAssignments = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentApproveMultipleAssignmentsHook>>
    >,
    TError,
    { data: AssignmentViewModel[] },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentApproveMultipleAssignmentsHook>>
  >,
  TError,
  { data: AssignmentViewModel[] },
  TContext
> => {
  const mutationOptions =
    useAssignmentApproveMultipleAssignmentsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook =
  () => {
    const assignmentApproveMultipleAssignmentsWithAutoApprovalConditions =
      useCustomInstance<string[]>();

    return useCallback(
      (
        assignmentWithAutoApprovalCondition: AssignmentWithAutoApprovalCondition[]
      ) => {
        return assignmentApproveMultipleAssignmentsWithAutoApprovalConditions({
          url: `/api/Assignment/ApproveMultipleAssignmentsWithAutoApprovalConditions`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: assignmentWithAutoApprovalCondition,
        });
      },
      [assignmentApproveMultipleAssignmentsWithAutoApprovalConditions]
    );
  };

export const useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook
          >
        >
      >,
      TError,
      { data: AssignmentWithAutoApprovalCondition[] },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook
        >
      >
    >,
    TError,
    { data: AssignmentWithAutoApprovalCondition[] },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentApproveMultipleAssignmentsWithAutoApprovalConditions =
      useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook
          >
        >
      >,
      { data: AssignmentWithAutoApprovalCondition[] }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentApproveMultipleAssignmentsWithAutoApprovalConditions(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook
        >
      >
    >
  >;
export type AssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsMutationBody =
  AssignmentWithAutoApprovalCondition[];
export type AssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsMutationError =
  unknown;

export const useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook
          >
        >
      >,
      TError,
      { data: AssignmentWithAutoApprovalCondition[] },
      TContext
    >;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsHook
        >
      >
    >,
    TError,
    { data: AssignmentWithAutoApprovalCondition[] },
    TContext
  > => {
    const mutationOptions =
      useAssignmentApproveMultipleAssignmentsWithAutoApprovalConditionsMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };
export const useAssignmentGetExtendedAssignmentsHook = () => {
  const assignmentGetExtendedAssignments =
    useCustomInstance<AssignmentExtendedModel[]>();

  return useCallback(
    (
      assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody
    ) => {
      return assignmentGetExtendedAssignments({
        url: `/api/Assignment/GetExtendedAssignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
      });
    },
    [assignmentGetExtendedAssignments]
  );
};

export const useAssignmentGetExtendedAssignmentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetExtendedAssignmentsHook>>
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetExtendedAssignmentsHook>>
  >,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetExtendedAssignments =
    useAssignmentGetExtendedAssignmentsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetExtendedAssignmentsHook>>
    >,
    { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentGetExtendedAssignments(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetExtendedAssignmentsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetExtendedAssignmentsHook>>
  >
>;
export type AssignmentGetExtendedAssignmentsMutationBody =
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
export type AssignmentGetExtendedAssignmentsMutationError = unknown;

export const useAssignmentGetExtendedAssignments = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetExtendedAssignmentsHook>>
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetExtendedAssignmentsHook>>
  >,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetExtendedAssignmentsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentSearchAssignmentHook = () => {
  const assignmentSearchAssignment = useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (searchAssignmentsRequestBody: SearchAssignmentsRequestBody) => {
      return assignmentSearchAssignment({
        url: `/api/Assignment/SearchAssignment`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchAssignmentsRequestBody,
      });
    },
    [assignmentSearchAssignment]
  );
};

export const useAssignmentSearchAssignmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentSearchAssignmentHook>>>,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentSearchAssignmentHook>>>,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSearchAssignment = useAssignmentSearchAssignmentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentSearchAssignmentHook>>>,
    { data: SearchAssignmentsRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentSearchAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSearchAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentSearchAssignmentHook>>>
>;
export type AssignmentSearchAssignmentMutationBody =
  SearchAssignmentsRequestBody;
export type AssignmentSearchAssignmentMutationError = unknown;

export const useAssignmentSearchAssignment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentSearchAssignmentHook>>>,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentSearchAssignmentHook>>>,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const mutationOptions = useAssignmentSearchAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentSearchAssignmentWithPagingHook = () => {
  const assignmentSearchAssignmentWithPaging =
    useCustomInstance<AssignmentViewModelSearchResult>();

  return useCallback(
    (searchAssignmentsRequestBody: SearchAssignmentsRequestBody) => {
      return assignmentSearchAssignmentWithPaging({
        url: `/api/Assignment/SearchAssignmentWithPaging`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchAssignmentsRequestBody,
      });
    },
    [assignmentSearchAssignmentWithPaging]
  );
};

export const useAssignmentSearchAssignmentWithPagingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSearchAssignmentWithPagingHook>>
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSearchAssignmentWithPagingHook>>
  >,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSearchAssignmentWithPaging =
    useAssignmentSearchAssignmentWithPagingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSearchAssignmentWithPagingHook>>
    >,
    { data: SearchAssignmentsRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentSearchAssignmentWithPaging(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSearchAssignmentWithPagingMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSearchAssignmentWithPagingHook>>
  >
>;
export type AssignmentSearchAssignmentWithPagingMutationBody =
  SearchAssignmentsRequestBody;
export type AssignmentSearchAssignmentWithPagingMutationError = unknown;

export const useAssignmentSearchAssignmentWithPaging = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSearchAssignmentWithPagingHook>>
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSearchAssignmentWithPagingHook>>
  >,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const mutationOptions =
    useAssignmentSearchAssignmentWithPagingMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentSearchAllAssignmentsNoPagingHook = () => {
  const assignmentSearchAllAssignmentsNoPaging =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (searchAssignmentsRequestBody: SearchAssignmentsRequestBody) => {
      return assignmentSearchAllAssignmentsNoPaging({
        url: `/api/Assignment/SearchAllAssignmentsNoPaging`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchAssignmentsRequestBody,
      });
    },
    [assignmentSearchAllAssignmentsNoPaging]
  );
};

export const useAssignmentSearchAllAssignmentsNoPagingMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSearchAllAssignmentsNoPagingHook>
      >
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSearchAllAssignmentsNoPagingHook>>
  >,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSearchAllAssignmentsNoPaging =
    useAssignmentSearchAllAssignmentsNoPagingHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSearchAllAssignmentsNoPagingHook>
      >
    >,
    { data: SearchAssignmentsRequestBody }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentSearchAllAssignmentsNoPaging(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSearchAllAssignmentsNoPagingMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSearchAllAssignmentsNoPagingHook>>
  >
>;
export type AssignmentSearchAllAssignmentsNoPagingMutationBody =
  SearchAssignmentsRequestBody;
export type AssignmentSearchAllAssignmentsNoPagingMutationError = unknown;

export const useAssignmentSearchAllAssignmentsNoPaging = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSearchAllAssignmentsNoPagingHook>
      >
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSearchAllAssignmentsNoPagingHook>>
  >,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const mutationOptions =
    useAssignmentSearchAllAssignmentsNoPagingMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAssignmentsWithAutoApprovalConditionsHook = () => {
  const assignmentGetAssignmentsWithAutoApprovalConditions =
    useCustomInstance<AutoApprovalResponseDto>();

  return useCallback(
    (searchAssignmentsRequestBody: SearchAssignmentsRequestBody) => {
      return assignmentGetAssignmentsWithAutoApprovalConditions({
        url: `/api/Assignment/GetAssignmentsWithAutoApprovalConditions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchAssignmentsRequestBody,
      });
    },
    [assignmentGetAssignmentsWithAutoApprovalConditions]
  );
};

export const useAssignmentGetAssignmentsWithAutoApprovalConditionsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignmentsWithAutoApprovalConditionsHook
          >
        >
      >,
      TError,
      { data: SearchAssignmentsRequestBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsWithAutoApprovalConditionsHook
        >
      >
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentGetAssignmentsWithAutoApprovalConditions =
      useAssignmentGetAssignmentsWithAutoApprovalConditionsHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignmentsWithAutoApprovalConditionsHook
          >
        >
      >,
      { data: SearchAssignmentsRequestBody }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentGetAssignmentsWithAutoApprovalConditions(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentGetAssignmentsWithAutoApprovalConditionsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsWithAutoApprovalConditionsHook
        >
      >
    >
  >;
export type AssignmentGetAssignmentsWithAutoApprovalConditionsMutationBody =
  SearchAssignmentsRequestBody;
export type AssignmentGetAssignmentsWithAutoApprovalConditionsMutationError =
  unknown;

export const useAssignmentGetAssignmentsWithAutoApprovalConditions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsWithAutoApprovalConditionsHook
        >
      >
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetAssignmentsWithAutoApprovalConditionsHook
      >
    >
  >,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetAssignmentsWithAutoApprovalConditionsMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useAssignmentGetAutoApproveCheckResultDetailsHook = () => {
  const assignmentGetAutoApproveCheckResultDetails =
    useCustomInstance<AutoApproveResult>();

  return useCallback(
    (
      params?: AssignmentGetAutoApproveCheckResultDetailsParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAutoApproveCheckResultDetails({
        url: `/api/Assignment/GetAutoApproveCheckResultDetails`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAutoApproveCheckResultDetails]
  );
};

export const getAssignmentGetAutoApproveCheckResultDetailsQueryKey = (
  params?: AssignmentGetAutoApproveCheckResultDetailsParams
) => {
  return [
    `/api/Assignment/GetAutoApproveCheckResultDetails`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAutoApproveCheckResultDetailsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveCheckResultDetailsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveCheckResultDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveCheckResultDetailsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAutoApproveCheckResultDetailsQueryKey(params);

  const assignmentGetAutoApproveCheckResultDetails =
    useAssignmentGetAutoApproveCheckResultDetailsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveCheckResultDetailsHook>
      >
    >
  > = ({ signal }) =>
    assignmentGetAutoApproveCheckResultDetails(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveCheckResultDetailsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveCheckResultDetailsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveCheckResultDetailsHook>
    >
  >
>;
export type AssignmentGetAutoApproveCheckResultDetailsQueryError = unknown;

export const useAssignmentGetAutoApproveCheckResultDetails = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveCheckResultDetailsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveCheckResultDetailsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveCheckResultDetailsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAutoApproveCheckResultDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAutoApproveChecksForCaseHook = () => {
  const assignmentGetAutoApproveChecksForCase =
    useCustomInstance<AssignmentAutoApproveCheckDto[]>();

  return useCallback(
    (
      params?: AssignmentGetAutoApproveChecksForCaseParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAutoApproveChecksForCase({
        url: `/api/Assignment/GetAutoApproveChecksForCase`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAutoApproveChecksForCase]
  );
};

export const getAssignmentGetAutoApproveChecksForCaseQueryKey = (
  params?: AssignmentGetAutoApproveChecksForCaseParams
) => {
  return [
    `/api/Assignment/GetAutoApproveChecksForCase`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAutoApproveChecksForCaseQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveChecksForCaseHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveChecksForCaseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveChecksForCaseHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAutoApproveChecksForCaseQueryKey(params);

  const assignmentGetAutoApproveChecksForCase =
    useAssignmentGetAutoApproveChecksForCaseHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveChecksForCaseHook>
      >
    >
  > = ({ signal }) => assignmentGetAutoApproveChecksForCase(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveChecksForCaseHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveChecksForCaseQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveChecksForCaseHook>>
  >
>;
export type AssignmentGetAutoApproveChecksForCaseQueryError = unknown;

export const useAssignmentGetAutoApproveChecksForCase = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveChecksForCaseHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveChecksForCaseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveChecksForCaseHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetAutoApproveChecksForCaseQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentRefreshAutoApproveChecksHook = () => {
  const assignmentRefreshAutoApproveChecks = useCustomInstance<Blob>();

  return useCallback(
    (
      assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody
    ) => {
      return assignmentRefreshAutoApproveChecks({
        url: `/api/Assignment/RefreshAutoApproveChecks`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody,
        responseType: 'blob',
      });
    },
    [assignmentRefreshAutoApproveChecks]
  );
};

export const useAssignmentRefreshAutoApproveChecksMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRefreshAutoApproveChecksHook>>
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRefreshAutoApproveChecksHook>>
  >,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentRefreshAutoApproveChecks =
    useAssignmentRefreshAutoApproveChecksHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRefreshAutoApproveChecksHook>>
    >,
    { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentRefreshAutoApproveChecks(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentRefreshAutoApproveChecksMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRefreshAutoApproveChecksHook>>
  >
>;
export type AssignmentRefreshAutoApproveChecksMutationBody =
  AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
export type AssignmentRefreshAutoApproveChecksMutationError = unknown;

export const useAssignmentRefreshAutoApproveChecks = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRefreshAutoApproveChecksHook>>
    >,
    TError,
    {
      data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRefreshAutoApproveChecksHook>>
  >,
  TError,
  { data: AssignmentRequestsHandOutCarKeysToTransportDriverAssignmentidsBody },
  TContext
> => {
  const mutationOptions =
    useAssignmentRefreshAutoApproveChecksMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentRefreshAllAutoApproveChecksForFilterHook = () => {
  const assignmentRefreshAllAutoApproveChecksForFilter =
    useCustomInstance<number>();

  return useCallback(
    (searchAssignmentsRequestBody: SearchAssignmentsRequestBody) => {
      return assignmentRefreshAllAutoApproveChecksForFilter({
        url: `/api/Assignment/RefreshAllAutoApproveChecksForFilter`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: searchAssignmentsRequestBody,
      });
    },
    [assignmentRefreshAllAutoApproveChecksForFilter]
  );
};

export const useAssignmentRefreshAllAutoApproveChecksForFilterMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentRefreshAllAutoApproveChecksForFilterHook
          >
        >
      >,
      TError,
      { data: SearchAssignmentsRequestBody },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentRefreshAllAutoApproveChecksForFilterHook>
      >
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentRefreshAllAutoApproveChecksForFilter =
      useAssignmentRefreshAllAutoApproveChecksForFilterHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentRefreshAllAutoApproveChecksForFilterHook
          >
        >
      >,
      { data: SearchAssignmentsRequestBody }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentRefreshAllAutoApproveChecksForFilter(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentRefreshAllAutoApproveChecksForFilterMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentRefreshAllAutoApproveChecksForFilterHook>
      >
    >
  >;
export type AssignmentRefreshAllAutoApproveChecksForFilterMutationBody =
  SearchAssignmentsRequestBody;
export type AssignmentRefreshAllAutoApproveChecksForFilterMutationError =
  unknown;

export const useAssignmentRefreshAllAutoApproveChecksForFilter = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentRefreshAllAutoApproveChecksForFilterHook>
      >
    >,
    TError,
    { data: SearchAssignmentsRequestBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentRefreshAllAutoApproveChecksForFilterHook>
    >
  >,
  TError,
  { data: SearchAssignmentsRequestBody },
  TContext
> => {
  const mutationOptions =
    useAssignmentRefreshAllAutoApproveChecksForFilterMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentDebugRunAutoAnalysisForFTDayHook = () => {
  const assignmentDebugRunAutoAnalysisForFTDay = useCustomInstance<Blob>();

  return useCallback(
    (params?: AssignmentDebugRunAutoAnalysisForFTDayParams) => {
      return assignmentDebugRunAutoAnalysisForFTDay({
        url: `/api/Assignment/DebugRunAutoAnalysisForFTDay`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [assignmentDebugRunAutoAnalysisForFTDay]
  );
};

export const useAssignmentDebugRunAutoAnalysisForFTDayMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentDebugRunAutoAnalysisForFTDayHook>
      >
    >,
    TError,
    { params?: AssignmentDebugRunAutoAnalysisForFTDayParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDebugRunAutoAnalysisForFTDayHook>>
  >,
  TError,
  { params?: AssignmentDebugRunAutoAnalysisForFTDayParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentDebugRunAutoAnalysisForFTDay =
    useAssignmentDebugRunAutoAnalysisForFTDayHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentDebugRunAutoAnalysisForFTDayHook>
      >
    >,
    { params?: AssignmentDebugRunAutoAnalysisForFTDayParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentDebugRunAutoAnalysisForFTDay(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentDebugRunAutoAnalysisForFTDayMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDebugRunAutoAnalysisForFTDayHook>>
  >
>;

export type AssignmentDebugRunAutoAnalysisForFTDayMutationError = unknown;

export const useAssignmentDebugRunAutoAnalysisForFTDay = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentDebugRunAutoAnalysisForFTDayHook>
      >
    >,
    TError,
    { params?: AssignmentDebugRunAutoAnalysisForFTDayParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDebugRunAutoAnalysisForFTDayHook>>
  >,
  TError,
  { params?: AssignmentDebugRunAutoAnalysisForFTDayParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentDebugRunAutoAnalysisForFTDayMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentDebugSeedGpsPositionsHook = () => {
  const assignmentDebugSeedGpsPositions = useCustomInstance<Blob>();

  return useCallback(
    (params?: AssignmentDebugSeedGpsPositionsParams) => {
      return assignmentDebugSeedGpsPositions({
        url: `/api/Assignment/DebugSeedGpsPositions`,
        method: 'POST',
        params,
        responseType: 'blob',
      });
    },
    [assignmentDebugSeedGpsPositions]
  );
};

export const useAssignmentDebugSeedGpsPositionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentDebugSeedGpsPositionsHook>>
    >,
    TError,
    { params?: AssignmentDebugSeedGpsPositionsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDebugSeedGpsPositionsHook>>
  >,
  TError,
  { params?: AssignmentDebugSeedGpsPositionsParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentDebugSeedGpsPositions =
    useAssignmentDebugSeedGpsPositionsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentDebugSeedGpsPositionsHook>>
    >,
    { params?: AssignmentDebugSeedGpsPositionsParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentDebugSeedGpsPositions(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentDebugSeedGpsPositionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentDebugSeedGpsPositionsHook>>>
>;

export type AssignmentDebugSeedGpsPositionsMutationError = unknown;

export const useAssignmentDebugSeedGpsPositions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentDebugSeedGpsPositionsHook>>
    >,
    TError,
    { params?: AssignmentDebugSeedGpsPositionsParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDebugSeedGpsPositionsHook>>
  >,
  TError,
  { params?: AssignmentDebugSeedGpsPositionsParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentDebugSeedGpsPositionsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAutoApproveAnalyticsHook = () => {
  const assignmentGetAutoApproveAnalytics =
    useCustomInstance<AutoApproveAnalyticsResult>();

  return useCallback(
    (
      params?: AssignmentGetAutoApproveAnalyticsParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAutoApproveAnalytics({
        url: `/api/Assignment/GetAutoApproveAnalytics`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAutoApproveAnalytics]
  );
};

export const getAssignmentGetAutoApproveAnalyticsQueryKey = (
  params?: AssignmentGetAutoApproveAnalyticsParams
) => {
  return [
    `/api/Assignment/GetAutoApproveAnalytics`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAutoApproveAnalyticsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveAnalyticsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetAutoApproveAnalyticsHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAutoApproveAnalyticsQueryKey(params);

  const assignmentGetAutoApproveAnalytics =
    useAssignmentGetAutoApproveAnalyticsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveAnalyticsHook>>
    >
  > = ({ signal }) => assignmentGetAutoApproveAnalytics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveAnalyticsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveAnalyticsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveAnalyticsHook>>
  >
>;
export type AssignmentGetAutoApproveAnalyticsQueryError = unknown;

export const useAssignmentGetAutoApproveAnalytics = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveAnalyticsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetAutoApproveAnalyticsHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetAutoApproveAnalyticsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAutoApproveBlockedAssignmentsHook = () => {
  const assignmentGetAutoApproveBlockedAssignments =
    useCustomInstance<BlockedAssignmentDetail[]>();

  return useCallback(
    (
      params?: AssignmentGetAutoApproveBlockedAssignmentsParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAutoApproveBlockedAssignments({
        url: `/api/Assignment/GetAutoApproveBlockedAssignments`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAutoApproveBlockedAssignments]
  );
};

export const getAssignmentGetAutoApproveBlockedAssignmentsQueryKey = (
  params?: AssignmentGetAutoApproveBlockedAssignmentsParams
) => {
  return [
    `/api/Assignment/GetAutoApproveBlockedAssignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAutoApproveBlockedAssignmentsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveBlockedAssignmentsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveBlockedAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveBlockedAssignmentsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAutoApproveBlockedAssignmentsQueryKey(params);

  const assignmentGetAutoApproveBlockedAssignments =
    useAssignmentGetAutoApproveBlockedAssignmentsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveBlockedAssignmentsHook>
      >
    >
  > = ({ signal }) =>
    assignmentGetAutoApproveBlockedAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveBlockedAssignmentsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveBlockedAssignmentsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveBlockedAssignmentsHook>
    >
  >
>;
export type AssignmentGetAutoApproveBlockedAssignmentsQueryError = unknown;

export const useAssignmentGetAutoApproveBlockedAssignments = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveBlockedAssignmentsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveBlockedAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveBlockedAssignmentsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAutoApproveBlockedAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAutoApproveUnApprovalAnalyticsHook = () => {
  const assignmentGetAutoApproveUnApprovalAnalytics =
    useCustomInstance<UnApprovalAnalyticsResult>();

  return useCallback(
    (
      params?: AssignmentGetAutoApproveUnApprovalAnalyticsParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAutoApproveUnApprovalAnalytics({
        url: `/api/Assignment/GetAutoApproveUnApprovalAnalytics`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAutoApproveUnApprovalAnalytics]
  );
};

export const getAssignmentGetAutoApproveUnApprovalAnalyticsQueryKey = (
  params?: AssignmentGetAutoApproveUnApprovalAnalyticsParams
) => {
  return [
    `/api/Assignment/GetAutoApproveUnApprovalAnalytics`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAutoApproveUnApprovalAnalyticsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveUnApprovalAnalyticsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveUnApprovalAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveUnApprovalAnalyticsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAutoApproveUnApprovalAnalyticsQueryKey(params);

  const assignmentGetAutoApproveUnApprovalAnalytics =
    useAssignmentGetAutoApproveUnApprovalAnalyticsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveUnApprovalAnalyticsHook>
      >
    >
  > = ({ signal }) =>
    assignmentGetAutoApproveUnApprovalAnalytics(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveUnApprovalAnalyticsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveUnApprovalAnalyticsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveUnApprovalAnalyticsHook>
      >
    >
  >;
export type AssignmentGetAutoApproveUnApprovalAnalyticsQueryError = unknown;

export const useAssignmentGetAutoApproveUnApprovalAnalytics = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveUnApprovalAnalyticsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveUnApprovalAnalyticsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveUnApprovalAnalyticsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAutoApproveUnApprovalAnalyticsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAutoApproveQualityFlagsHook = () => {
  const assignmentGetAutoApproveQualityFlags =
    useCustomInstance<AutoApproveQualityFlagsResult>();

  return useCallback(
    (
      params?: AssignmentGetAutoApproveQualityFlagsParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAutoApproveQualityFlags({
        url: `/api/Assignment/GetAutoApproveQualityFlags`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAutoApproveQualityFlags]
  );
};

export const getAssignmentGetAutoApproveQualityFlagsQueryKey = (
  params?: AssignmentGetAutoApproveQualityFlagsParams
) => {
  return [
    `/api/Assignment/GetAutoApproveQualityFlags`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAutoApproveQualityFlagsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveQualityFlagsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveQualityFlagsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveQualityFlagsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAutoApproveQualityFlagsQueryKey(params);

  const assignmentGetAutoApproveQualityFlags =
    useAssignmentGetAutoApproveQualityFlagsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveQualityFlagsHook>>
    >
  > = ({ signal }) => assignmentGetAutoApproveQualityFlags(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveQualityFlagsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveQualityFlagsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveQualityFlagsHook>>
  >
>;
export type AssignmentGetAutoApproveQualityFlagsQueryError = unknown;

export const useAssignmentGetAutoApproveQualityFlags = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveQualityFlagsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAutoApproveQualityFlagsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAutoApproveQualityFlagsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetAutoApproveQualityFlagsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @deprecated
 */
export const useAssignmentGetAssignmentHook = () => {
  const assignmentGetAssignment = useCustomInstance<AssignmentExtendedModel>();

  return useCallback(
    (params?: AssignmentGetAssignmentParams) => {
      return assignmentGetAssignment({
        url: `/api/Assignment/GetAssignment`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetAssignment]
  );
};

export const useAssignmentGetAssignmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentHook>>>,
    TError,
    { params?: AssignmentGetAssignmentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentHook>>>,
  TError,
  { params?: AssignmentGetAssignmentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetAssignment = useAssignmentGetAssignmentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentHook>>>,
    { params?: AssignmentGetAssignmentParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGetAssignment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentHook>>>
>;

export type AssignmentGetAssignmentMutationError = unknown;

/**
 * @deprecated
 */
export const useAssignmentGetAssignment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentHook>>>,
    TError,
    { params?: AssignmentGetAssignmentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentHook>>>,
  TError,
  { params?: AssignmentGetAssignmentParams },
  TContext
> => {
  const mutationOptions = useAssignmentGetAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentFindAssignmentByIDHook = () => {
  const assignmentFindAssignmentByID =
    useCustomInstance<AssignmentExtendedModel>();

  return useCallback(
    (params?: AssignmentFindAssignmentByIDParams, signal?: AbortSignal) => {
      return assignmentFindAssignmentByID({
        url: `/api/Assignment/FindAssignmentByID`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentFindAssignmentByID]
  );
};

export const getAssignmentFindAssignmentByIDQueryKey = (
  params?: AssignmentFindAssignmentByIDParams
) => {
  return [
    `/api/Assignment/FindAssignmentByID`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentFindAssignmentByIDQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentFindAssignmentByIDParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssignmentFindAssignmentByIDQueryKey(params);

  const assignmentFindAssignmentByID = useAssignmentFindAssignmentByIDHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDHook>>>
  > = ({ signal }) => assignmentFindAssignmentByID(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentFindAssignmentByIDQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDHook>>>
>;
export type AssignmentFindAssignmentByIDQueryError = unknown;

export const useAssignmentFindAssignmentByID = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentFindAssignmentByIDParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentFindAssignmentByIDQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentFindAssignmentByIDWithParamsHook = () => {
  const assignmentFindAssignmentByIDWithParams =
    useCustomInstance<AssignmentExtendedModel>();

  return useCallback(
    (
      params?: AssignmentFindAssignmentByIDWithParamsParams,
      signal?: AbortSignal
    ) => {
      return assignmentFindAssignmentByIDWithParams({
        url: `/api/Assignment/FindAssignmentByIDWithParams`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentFindAssignmentByIDWithParams]
  );
};

export const getAssignmentFindAssignmentByIDWithParamsQueryKey = (
  params?: AssignmentFindAssignmentByIDWithParamsParams
) => {
  return [
    `/api/Assignment/FindAssignmentByIDWithParams`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentFindAssignmentByIDWithParamsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDWithParamsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentFindAssignmentByIDWithParamsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentFindAssignmentByIDWithParamsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentFindAssignmentByIDWithParamsQueryKey(params);

  const assignmentFindAssignmentByIDWithParams =
    useAssignmentFindAssignmentByIDWithParamsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentFindAssignmentByIDWithParamsHook>
      >
    >
  > = ({ signal }) => assignmentFindAssignmentByIDWithParams(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentFindAssignmentByIDWithParamsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentFindAssignmentByIDWithParamsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDWithParamsHook>>
  >
>;
export type AssignmentFindAssignmentByIDWithParamsQueryError = unknown;

export const useAssignmentFindAssignmentByIDWithParams = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentFindAssignmentByIDWithParamsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentFindAssignmentByIDWithParamsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentFindAssignmentByIDWithParamsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentFindAssignmentByIDWithParamsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentFindMyAssignmentByIDWithParamsHook = () => {
  const assignmentFindMyAssignmentByIDWithParams =
    useCustomInstance<AssignmentExtendedModel>();

  return useCallback(
    (
      params?: AssignmentFindMyAssignmentByIDWithParamsParams,
      signal?: AbortSignal
    ) => {
      return assignmentFindMyAssignmentByIDWithParams({
        url: `/api/Assignment/FindMyAssignmentByIDWithParams`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentFindMyAssignmentByIDWithParams]
  );
};

export const getAssignmentFindMyAssignmentByIDWithParamsQueryKey = (
  params?: AssignmentFindMyAssignmentByIDWithParamsParams
) => {
  return [
    `/api/Assignment/FindMyAssignmentByIDWithParams`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentFindMyAssignmentByIDWithParamsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentFindMyAssignmentByIDWithParamsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentFindMyAssignmentByIDWithParamsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentFindMyAssignmentByIDWithParamsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentFindMyAssignmentByIDWithParamsQueryKey(params);

  const assignmentFindMyAssignmentByIDWithParams =
    useAssignmentFindMyAssignmentByIDWithParamsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentFindMyAssignmentByIDWithParamsHook>
      >
    >
  > = ({ signal }) => assignmentFindMyAssignmentByIDWithParams(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentFindMyAssignmentByIDWithParamsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentFindMyAssignmentByIDWithParamsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentFindMyAssignmentByIDWithParamsHook>
    >
  >
>;
export type AssignmentFindMyAssignmentByIDWithParamsQueryError = unknown;

export const useAssignmentFindMyAssignmentByIDWithParams = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentFindMyAssignmentByIDWithParamsHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentFindMyAssignmentByIDWithParamsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentFindMyAssignmentByIDWithParamsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentFindMyAssignmentByIDWithParamsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAssignmentsForUserHook = () => {
  const assignmentGetAssignmentsForUser =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (params?: AssignmentGetAssignmentsForUserParams) => {
      return assignmentGetAssignmentsForUser({
        url: `/api/Assignment/GetAssignmentsForUser`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetAssignmentsForUser]
  );
};

export const useAssignmentGetAssignmentsForUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAssignmentsForUserHook>>
    >,
    TError,
    { params?: AssignmentGetAssignmentsForUserParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAssignmentsForUserHook>>
  >,
  TError,
  { params?: AssignmentGetAssignmentsForUserParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetAssignmentsForUser =
    useAssignmentGetAssignmentsForUserHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAssignmentsForUserHook>>
    >,
    { params?: AssignmentGetAssignmentsForUserParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGetAssignmentsForUser(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetAssignmentsForUserMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentsForUserHook>>>
>;

export type AssignmentGetAssignmentsForUserMutationError = unknown;

export const useAssignmentGetAssignmentsForUser = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAssignmentsForUserHook>>
    >,
    TError,
    { params?: AssignmentGetAssignmentsForUserParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAssignmentsForUserHook>>
  >,
  TError,
  { params?: AssignmentGetAssignmentsForUserParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetAssignmentsForUserMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetActiveAssignmentsForUserHook = () => {
  const assignmentGetActiveAssignmentsForUser =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (params?: AssignmentGetActiveAssignmentsForUserParams) => {
      return assignmentGetActiveAssignmentsForUser({
        url: `/api/Assignment/GetActiveAssignmentsForUser`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetActiveAssignmentsForUser]
  );
};

export const useAssignmentGetActiveAssignmentsForUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetActiveAssignmentsForUserHook>
      >
    >,
    TError,
    { params?: AssignmentGetActiveAssignmentsForUserParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetActiveAssignmentsForUserHook>>
  >,
  TError,
  { params?: AssignmentGetActiveAssignmentsForUserParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetActiveAssignmentsForUser =
    useAssignmentGetActiveAssignmentsForUserHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetActiveAssignmentsForUserHook>
      >
    >,
    { params?: AssignmentGetActiveAssignmentsForUserParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGetActiveAssignmentsForUser(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetActiveAssignmentsForUserMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetActiveAssignmentsForUserHook>>
  >
>;

export type AssignmentGetActiveAssignmentsForUserMutationError = unknown;

export const useAssignmentGetActiveAssignmentsForUser = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetActiveAssignmentsForUserHook>
      >
    >,
    TError,
    { params?: AssignmentGetActiveAssignmentsForUserParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetActiveAssignmentsForUserHook>>
  >,
  TError,
  { params?: AssignmentGetActiveAssignmentsForUserParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetActiveAssignmentsForUserMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetFinishedAssignmentsForUserHook = () => {
  const assignmentGetFinishedAssignmentsForUser =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (getFinishedAssignmentsRequest: GetFinishedAssignmentsRequest) => {
      return assignmentGetFinishedAssignmentsForUser({
        url: `/api/Assignment/GetFinishedAssignmentsForUser`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: getFinishedAssignmentsRequest,
      });
    },
    [assignmentGetFinishedAssignmentsForUser]
  );
};

export const useAssignmentGetFinishedAssignmentsForUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFinishedAssignmentsForUserHook>
      >
    >,
    TError,
    { data: GetFinishedAssignmentsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFinishedAssignmentsForUserHook>
    >
  >,
  TError,
  { data: GetFinishedAssignmentsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetFinishedAssignmentsForUser =
    useAssignmentGetFinishedAssignmentsForUserHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFinishedAssignmentsForUserHook>
      >
    >,
    { data: GetFinishedAssignmentsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentGetFinishedAssignmentsForUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetFinishedAssignmentsForUserMutationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFinishedAssignmentsForUserHook>
    >
  >
>;
export type AssignmentGetFinishedAssignmentsForUserMutationBody =
  GetFinishedAssignmentsRequest;
export type AssignmentGetFinishedAssignmentsForUserMutationError = unknown;

export const useAssignmentGetFinishedAssignmentsForUser = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFinishedAssignmentsForUserHook>
      >
    >,
    TError,
    { data: GetFinishedAssignmentsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFinishedAssignmentsForUserHook>
    >
  >,
  TError,
  { data: GetFinishedAssignmentsRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetFinishedAssignmentsForUserMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetBookedAssignmentsForUserAndDateHook = () => {
  const assignmentGetBookedAssignmentsForUserAndDate =
    useCustomInstance<GetBookedAssignmentsForUserAndDateList>();

  return useCallback(
    (params?: AssignmentGetBookedAssignmentsForUserAndDateParams) => {
      return assignmentGetBookedAssignmentsForUserAndDate({
        url: `/api/Assignment/GetBookedAssignmentsForUserAndDate`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetBookedAssignmentsForUserAndDate]
  );
};

export const useAssignmentGetBookedAssignmentsForUserAndDateMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetBookedAssignmentsForUserAndDateHook>
      >
    >,
    TError,
    { params?: AssignmentGetBookedAssignmentsForUserAndDateParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetBookedAssignmentsForUserAndDateHook>
    >
  >,
  TError,
  { params?: AssignmentGetBookedAssignmentsForUserAndDateParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetBookedAssignmentsForUserAndDate =
    useAssignmentGetBookedAssignmentsForUserAndDateHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetBookedAssignmentsForUserAndDateHook>
      >
    >,
    { params?: AssignmentGetBookedAssignmentsForUserAndDateParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGetBookedAssignmentsForUserAndDate(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetBookedAssignmentsForUserAndDateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetBookedAssignmentsForUserAndDateHook>
      >
    >
  >;

export type AssignmentGetBookedAssignmentsForUserAndDateMutationError = unknown;

export const useAssignmentGetBookedAssignmentsForUserAndDate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetBookedAssignmentsForUserAndDateHook>
      >
    >,
    TError,
    { params?: AssignmentGetBookedAssignmentsForUserAndDateParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetBookedAssignmentsForUserAndDateHook>
    >
  >,
  TError,
  { params?: AssignmentGetBookedAssignmentsForUserAndDateParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetBookedAssignmentsForUserAndDateMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetGpsPausesForUserAndDateHook = () => {
  const assignmentGetGpsPausesForUserAndDate =
    useCustomInstance<GpsDayTrackWithPausesDto>();

  return useCallback(
    (
      params?: AssignmentGetGpsPausesForUserAndDateParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetGpsPausesForUserAndDate({
        url: `/api/Assignment/GetGpsPausesForUserAndDate`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetGpsPausesForUserAndDate]
  );
};

export const getAssignmentGetGpsPausesForUserAndDateQueryKey = (
  params?: AssignmentGetGpsPausesForUserAndDateParams
) => {
  return [
    `/api/Assignment/GetGpsPausesForUserAndDate`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetGpsPausesForUserAndDateQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetGpsPausesForUserAndDateHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetGpsPausesForUserAndDateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetGpsPausesForUserAndDateHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetGpsPausesForUserAndDateQueryKey(params);

  const assignmentGetGpsPausesForUserAndDate =
    useAssignmentGetGpsPausesForUserAndDateHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetGpsPausesForUserAndDateHook>>
    >
  > = ({ signal }) => assignmentGetGpsPausesForUserAndDate(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetGpsPausesForUserAndDateHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetGpsPausesForUserAndDateQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetGpsPausesForUserAndDateHook>>
  >
>;
export type AssignmentGetGpsPausesForUserAndDateQueryError = unknown;

export const useAssignmentGetGpsPausesForUserAndDate = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetGpsPausesForUserAndDateHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetGpsPausesForUserAndDateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetGpsPausesForUserAndDateHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetGpsPausesForUserAndDateQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetHoursWorkedHook = () => {
  const assignmentGetHoursWorked = useCustomInstance<WorkedHours>();

  return useCallback(
    (params?: AssignmentGetHoursWorkedParams) => {
      return assignmentGetHoursWorked({
        url: `/api/Assignment/GetHoursWorked`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetHoursWorked]
  );
};

export const useAssignmentGetHoursWorkedMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetHoursWorkedHook>>>,
    TError,
    { params?: AssignmentGetHoursWorkedParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetHoursWorkedHook>>>,
  TError,
  { params?: AssignmentGetHoursWorkedParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetHoursWorked = useAssignmentGetHoursWorkedHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetHoursWorkedHook>>>,
    { params?: AssignmentGetHoursWorkedParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGetHoursWorked(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetHoursWorkedMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetHoursWorkedHook>>>
>;

export type AssignmentGetHoursWorkedMutationError = unknown;

export const useAssignmentGetHoursWorked = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetHoursWorkedHook>>>,
    TError,
    { params?: AssignmentGetHoursWorkedParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetHoursWorkedHook>>>,
  TError,
  { params?: AssignmentGetHoursWorkedParams },
  TContext
> => {
  const mutationOptions = useAssignmentGetHoursWorkedMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAssignmentByIdHook = () => {
  const assignmentGetAssignmentById = useCustomInstance<AssignmentViewModel>();

  return useCallback(
    (params?: AssignmentGetAssignmentByIdParams) => {
      return assignmentGetAssignmentById({
        url: `/api/Assignment/GetAssignmentById`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetAssignmentById]
  );
};

export const useAssignmentGetAssignmentByIdMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentByIdHook>>>,
    TError,
    { params?: AssignmentGetAssignmentByIdParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentByIdHook>>>,
  TError,
  { params?: AssignmentGetAssignmentByIdParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetAssignmentById = useAssignmentGetAssignmentByIdHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentByIdHook>>>,
    { params?: AssignmentGetAssignmentByIdParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGetAssignmentById(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetAssignmentByIdMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentByIdHook>>>
>;

export type AssignmentGetAssignmentByIdMutationError = unknown;

export const useAssignmentGetAssignmentById = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentByIdHook>>>,
    TError,
    { params?: AssignmentGetAssignmentByIdParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentByIdHook>>>,
  TError,
  { params?: AssignmentGetAssignmentByIdParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetAssignmentByIdMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook =
  () => {
    const assignmentGetUnassignedFurtherTransportAssignmentByRegNr =
      useCustomInstance<AssignmentViewModel>();

    return useCallback(
      (
        params?: AssignmentGetUnassignedFurtherTransportAssignmentByRegNrParams
      ) => {
        return assignmentGetUnassignedFurtherTransportAssignmentByRegNr({
          url: `/api/Assignment/GetUnassignedFurtherTransportAssignmentByRegNr`,
          method: 'POST',
          params,
        });
      },
      [assignmentGetUnassignedFurtherTransportAssignmentByRegNr]
    );
  };

export const useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentGetUnassignedFurtherTransportAssignmentByRegNrParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook
        >
      >
    >,
    TError,
    { params?: AssignmentGetUnassignedFurtherTransportAssignmentByRegNrParams },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentGetUnassignedFurtherTransportAssignmentByRegNr =
      useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook
          >
        >
      >,
      {
        params?: AssignmentGetUnassignedFurtherTransportAssignmentByRegNrParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentGetUnassignedFurtherTransportAssignmentByRegNr(params);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentGetUnassignedFurtherTransportAssignmentByRegNrMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook
        >
      >
    >
  >;

export type AssignmentGetUnassignedFurtherTransportAssignmentByRegNrMutationError =
  unknown;

export const useAssignmentGetUnassignedFurtherTransportAssignmentByRegNr = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook
        >
      >
    >,
    TError,
    { params?: AssignmentGetUnassignedFurtherTransportAssignmentByRegNrParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrHook
      >
    >
  >,
  TError,
  { params?: AssignmentGetUnassignedFurtherTransportAssignmentByRegNrParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetUnassignedFurtherTransportAssignmentByRegNrMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useAssignmentGetUnassignedAssignmentByRegNrHook = () => {
  const assignmentGetUnassignedAssignmentByRegNr =
    useCustomInstance<AssignmentViewModel>();

  return useCallback(
    (params?: AssignmentGetUnassignedAssignmentByRegNrParams) => {
      return assignmentGetUnassignedAssignmentByRegNr({
        url: `/api/Assignment/GetUnassignedAssignmentByRegNr`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetUnassignedAssignmentByRegNr]
  );
};

export const useAssignmentGetUnassignedAssignmentByRegNrMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentByRegNrHook>
      >
    >,
    TError,
    { params?: AssignmentGetUnassignedAssignmentByRegNrParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetUnassignedAssignmentByRegNrHook>
    >
  >,
  TError,
  { params?: AssignmentGetUnassignedAssignmentByRegNrParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetUnassignedAssignmentByRegNr =
    useAssignmentGetUnassignedAssignmentByRegNrHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentByRegNrHook>
      >
    >,
    { params?: AssignmentGetUnassignedAssignmentByRegNrParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentGetUnassignedAssignmentByRegNr(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetUnassignedAssignmentByRegNrMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentByRegNrHook>
      >
    >
  >;

export type AssignmentGetUnassignedAssignmentByRegNrMutationError = unknown;

export const useAssignmentGetUnassignedAssignmentByRegNr = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentByRegNrHook>
      >
    >,
    TError,
    { params?: AssignmentGetUnassignedAssignmentByRegNrParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetUnassignedAssignmentByRegNrHook>
    >
  >,
  TError,
  { params?: AssignmentGetUnassignedAssignmentByRegNrParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetUnassignedAssignmentByRegNrMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook =
  () => {
    const assignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByArea =
      useCustomInstance<AssignmentViewModel[]>();

    return useCallback(
      (
        params?: AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaParams
      ) => {
        return assignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByArea(
          {
            url: `/api/Assignment/GetUnassignedPurchasesAndFurtherTransportAssignmentsByArea`,
            method: 'POST',
            params,
          }
        );
      },
      [assignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByArea]
    );
  };

export const useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByArea =
      useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook
          >
        >
      >,
      {
        params?: AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByArea(
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook
        >
      >
    >
  >;

export type AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaMutationError =
  unknown;

export const useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByArea =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaParams;
      },
      TContext
    >;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaParams;
    },
    TContext
  > => {
    const mutationOptions =
      useAssignmentGetUnassignedPurchasesAndFurtherTransportAssignmentsByAreaMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };
export const useAssignmentGetUnassignedAssignmentsByAddressHook = () => {
  const assignmentGetUnassignedAssignmentsByAddress =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (addressBasedRequest: AddressBasedRequest) => {
      return assignmentGetUnassignedAssignmentsByAddress({
        url: `/api/Assignment/GetUnassignedAssignmentsByAddress`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: addressBasedRequest,
      });
    },
    [assignmentGetUnassignedAssignmentsByAddress]
  );
};

export const useAssignmentGetUnassignedAssignmentsByAddressMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentsByAddressHook>
      >
    >,
    TError,
    { data: AddressBasedRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetUnassignedAssignmentsByAddressHook>
    >
  >,
  TError,
  { data: AddressBasedRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetUnassignedAssignmentsByAddress =
    useAssignmentGetUnassignedAssignmentsByAddressHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentsByAddressHook>
      >
    >,
    { data: AddressBasedRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentGetUnassignedAssignmentsByAddress(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetUnassignedAssignmentsByAddressMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentsByAddressHook>
      >
    >
  >;
export type AssignmentGetUnassignedAssignmentsByAddressMutationBody =
  AddressBasedRequest;
export type AssignmentGetUnassignedAssignmentsByAddressMutationError = unknown;

export const useAssignmentGetUnassignedAssignmentsByAddress = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetUnassignedAssignmentsByAddressHook>
      >
    >,
    TError,
    { data: AddressBasedRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetUnassignedAssignmentsByAddressHook>
    >
  >,
  TError,
  { data: AddressBasedRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetUnassignedAssignmentsByAddressMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetUnassignedAssignmentsByAddressProximityHook =
  () => {
    const assignmentGetUnassignedAssignmentsByAddressProximity =
      useCustomInstance<AssignmentViewModel[]>();

    return useCallback(
      (proximityBasedRequest: ProximityBasedRequest) => {
        return assignmentGetUnassignedAssignmentsByAddressProximity({
          url: `/api/Assignment/GetUnassignedAssignmentsByAddressProximity`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: proximityBasedRequest,
        });
      },
      [assignmentGetUnassignedAssignmentsByAddressProximity]
    );
  };

export const useAssignmentGetUnassignedAssignmentsByAddressProximityMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetUnassignedAssignmentsByAddressProximityHook
          >
        >
      >,
      TError,
      { data: ProximityBasedRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedAssignmentsByAddressProximityHook
        >
      >
    >,
    TError,
    { data: ProximityBasedRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentGetUnassignedAssignmentsByAddressProximity =
      useAssignmentGetUnassignedAssignmentsByAddressProximityHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetUnassignedAssignmentsByAddressProximityHook
          >
        >
      >,
      { data: ProximityBasedRequest }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentGetUnassignedAssignmentsByAddressProximity(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentGetUnassignedAssignmentsByAddressProximityMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedAssignmentsByAddressProximityHook
        >
      >
    >
  >;
export type AssignmentGetUnassignedAssignmentsByAddressProximityMutationBody =
  ProximityBasedRequest;
export type AssignmentGetUnassignedAssignmentsByAddressProximityMutationError =
  unknown;

export const useAssignmentGetUnassignedAssignmentsByAddressProximity = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetUnassignedAssignmentsByAddressProximityHook
        >
      >
    >,
    TError,
    { data: ProximityBasedRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetUnassignedAssignmentsByAddressProximityHook
      >
    >
  >,
  TError,
  { data: ProximityBasedRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetUnassignedAssignmentsByAddressProximityMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook = () => {
  const assignmentGetActiveAssignmentByCaseTypeAndRegNr =
    useCustomInstance<AssignmentViewModel>();

  return useCallback(
    (params?: AssignmentGetActiveAssignmentByCaseTypeAndRegNrParams) => {
      return assignmentGetActiveAssignmentByCaseTypeAndRegNr({
        url: `/api/Assignment/GetActiveAssignmentByCaseTypeAndRegNr`,
        method: 'POST',
        params,
      });
    },
    [assignmentGetActiveAssignmentByCaseTypeAndRegNr]
  );
};

export const useAssignmentGetActiveAssignmentByCaseTypeAndRegNrMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook
          >
        >
      >,
      TError,
      { params?: AssignmentGetActiveAssignmentByCaseTypeAndRegNrParams },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook
        >
      >
    >,
    TError,
    { params?: AssignmentGetActiveAssignmentByCaseTypeAndRegNrParams },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentGetActiveAssignmentByCaseTypeAndRegNr =
      useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook
          >
        >
      >,
      { params?: AssignmentGetActiveAssignmentByCaseTypeAndRegNrParams }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentGetActiveAssignmentByCaseTypeAndRegNr(params);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentGetActiveAssignmentByCaseTypeAndRegNrMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook
        >
      >
    >
  >;

export type AssignmentGetActiveAssignmentByCaseTypeAndRegNrMutationError =
  unknown;

export const useAssignmentGetActiveAssignmentByCaseTypeAndRegNr = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook
        >
      >
    >,
    TError,
    { params?: AssignmentGetActiveAssignmentByCaseTypeAndRegNrParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetActiveAssignmentByCaseTypeAndRegNrHook>
    >
  >,
  TError,
  { params?: AssignmentGetActiveAssignmentByCaseTypeAndRegNrParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentGetActiveAssignmentByCaseTypeAndRegNrMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetDerivedEstimatedStartTimeHook = () => {
  const assignmentGetDerivedEstimatedStartTime = useCustomInstance<Date>();

  return useCallback(
    (
      params?: AssignmentGetDerivedEstimatedStartTimeParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetDerivedEstimatedStartTime({
        url: `/api/Assignment/GetDerivedEstimatedStartTime`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetDerivedEstimatedStartTime]
  );
};

export const getAssignmentGetDerivedEstimatedStartTimeQueryKey = (
  params?: AssignmentGetDerivedEstimatedStartTimeParams
) => {
  return [
    `/api/Assignment/GetDerivedEstimatedStartTime`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetDerivedEstimatedStartTimeQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetDerivedEstimatedStartTimeHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetDerivedEstimatedStartTimeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetDerivedEstimatedStartTimeHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetDerivedEstimatedStartTimeQueryKey(params);

  const assignmentGetDerivedEstimatedStartTime =
    useAssignmentGetDerivedEstimatedStartTimeHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetDerivedEstimatedStartTimeHook>
      >
    >
  > = ({ signal }) => assignmentGetDerivedEstimatedStartTime(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetDerivedEstimatedStartTimeHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetDerivedEstimatedStartTimeQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetDerivedEstimatedStartTimeHook>>
  >
>;
export type AssignmentGetDerivedEstimatedStartTimeQueryError = unknown;

export const useAssignmentGetDerivedEstimatedStartTime = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetDerivedEstimatedStartTimeHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetDerivedEstimatedStartTimeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetDerivedEstimatedStartTimeHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetDerivedEstimatedStartTimeQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetListHook = () => {
  const assignmentGetList = useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (getAssignmentsRequest: GetAssignmentsRequest) => {
      return assignmentGetList({
        url: `/api/Assignment/GetList`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: getAssignmentsRequest,
      });
    },
    [assignmentGetList]
  );
};

export const useAssignmentGetListMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetListHook>>>,
    TError,
    { data: GetAssignmentsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetListHook>>>,
  TError,
  { data: GetAssignmentsRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetList = useAssignmentGetListHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetListHook>>>,
    { data: GetAssignmentsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentGetList(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetListMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetListHook>>>
>;
export type AssignmentGetListMutationBody = GetAssignmentsRequest;
export type AssignmentGetListMutationError = unknown;

export const useAssignmentGetList = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetListHook>>>,
    TError,
    { data: GetAssignmentsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetListHook>>>,
  TError,
  { data: GetAssignmentsRequest },
  TContext
> => {
  const mutationOptions = useAssignmentGetListMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAssignmentsWithNewDataFromRideHook = () => {
  const assignmentGetAssignmentsWithNewDataFromRide =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(() => {
    return assignmentGetAssignmentsWithNewDataFromRide({
      url: `/api/Assignment/GetAssignmentsWithNewDataFromRide`,
      method: 'POST',
    });
  }, [assignmentGetAssignmentsWithNewDataFromRide]);
};

export const useAssignmentGetAssignmentsWithNewDataFromRideMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsWithNewDataFromRideHook>
      >
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsWithNewDataFromRideHook>
    >
  >,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentGetAssignmentsWithNewDataFromRide =
    useAssignmentGetAssignmentsWithNewDataFromRideHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsWithNewDataFromRideHook>
      >
    >,
    void
  > = () => {
    return assignmentGetAssignmentsWithNewDataFromRide();
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentGetAssignmentsWithNewDataFromRideMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsWithNewDataFromRideHook>
      >
    >
  >;

export type AssignmentGetAssignmentsWithNewDataFromRideMutationError = unknown;

export const useAssignmentGetAssignmentsWithNewDataFromRide = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsWithNewDataFromRideHook>
      >
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsWithNewDataFromRideHook>
    >
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useAssignmentGetAssignmentsWithNewDataFromRideMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAssignmentsWithNewDataFromRideCountHook = () => {
  const assignmentGetAssignmentsWithNewDataFromRideCount =
    useCustomInstance<number>();

  return useCallback(() => {
    return assignmentGetAssignmentsWithNewDataFromRideCount({
      url: `/api/Assignment/GetAssignmentsWithNewDataFromRideCount`,
      method: 'POST',
    });
  }, [assignmentGetAssignmentsWithNewDataFromRideCount]);
};

export const useAssignmentGetAssignmentsWithNewDataFromRideCountMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignmentsWithNewDataFromRideCountHook
          >
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsWithNewDataFromRideCountHook
        >
      >
    >,
    TError,
    void,
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentGetAssignmentsWithNewDataFromRideCount =
      useAssignmentGetAssignmentsWithNewDataFromRideCountHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignmentsWithNewDataFromRideCountHook
          >
        >
      >,
      void
    > = () => {
      return assignmentGetAssignmentsWithNewDataFromRideCount();
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentGetAssignmentsWithNewDataFromRideCountMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsWithNewDataFromRideCountHook
        >
      >
    >
  >;

export type AssignmentGetAssignmentsWithNewDataFromRideCountMutationError =
  unknown;

export const useAssignmentGetAssignmentsWithNewDataFromRideCount = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsWithNewDataFromRideCountHook
        >
      >
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsWithNewDataFromRideCountHook>
    >
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useAssignmentGetAssignmentsWithNewDataFromRideCountMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetFurtherTransportAssignmentsHook = () => {
  const assignmentGetFurtherTransportAssignments =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return assignmentGetFurtherTransportAssignments({
        url: `/api/Assignment/GetFurtherTransportAssignments`,
        method: 'GET',
        signal,
      });
    },
    [assignmentGetFurtherTransportAssignments]
  );
};

export const getAssignmentGetFurtherTransportAssignmentsQueryKey = () => {
  return [`/api/Assignment/GetFurtherTransportAssignments`] as const;
};

export const useAssignmentGetFurtherTransportAssignmentsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFurtherTransportAssignmentsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFurtherTransportAssignmentsHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetFurtherTransportAssignmentsQueryKey();

  const assignmentGetFurtherTransportAssignments =
    useAssignmentGetFurtherTransportAssignmentsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFurtherTransportAssignmentsHook>
      >
    >
  > = ({ signal }) => assignmentGetFurtherTransportAssignments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFurtherTransportAssignmentsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetFurtherTransportAssignmentsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFurtherTransportAssignmentsHook>
    >
  >
>;
export type AssignmentGetFurtherTransportAssignmentsQueryError = unknown;

export const useAssignmentGetFurtherTransportAssignments = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFurtherTransportAssignmentsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFurtherTransportAssignmentsHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetFurtherTransportAssignmentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetRideAlongCandidatesHook = () => {
  const assignmentGetRideAlongCandidates =
    useCustomInstance<RideAlongCandidateDto[]>();

  return useCallback(
    (params?: AssignmentGetRideAlongCandidatesParams, signal?: AbortSignal) => {
      return assignmentGetRideAlongCandidates({
        url: `/api/Assignment/GetRideAlongCandidates`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetRideAlongCandidates]
  );
};

export const getAssignmentGetRideAlongCandidatesQueryKey = (
  params?: AssignmentGetRideAlongCandidatesParams
) => {
  return [
    `/api/Assignment/GetRideAlongCandidates`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetRideAlongCandidatesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetRideAlongCandidatesHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetRideAlongCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetRideAlongCandidatesHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetRideAlongCandidatesQueryKey(params);

  const assignmentGetRideAlongCandidates =
    useAssignmentGetRideAlongCandidatesHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetRideAlongCandidatesHook>>
    >
  > = ({ signal }) => assignmentGetRideAlongCandidates(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetRideAlongCandidatesHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetRideAlongCandidatesQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetRideAlongCandidatesHook>>
  >
>;
export type AssignmentGetRideAlongCandidatesQueryError = unknown;

export const useAssignmentGetRideAlongCandidates = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetRideAlongCandidatesHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetRideAlongCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetRideAlongCandidatesHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetRideAlongCandidatesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetRideAlongLinksHook = () => {
  const assignmentGetRideAlongLinks = useCustomInstance<RideAlongLinksDto>();

  return useCallback(
    (params?: AssignmentGetRideAlongLinksParams, signal?: AbortSignal) => {
      return assignmentGetRideAlongLinks({
        url: `/api/Assignment/GetRideAlongLinks`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetRideAlongLinks]
  );
};

export const getAssignmentGetRideAlongLinksQueryKey = (
  params?: AssignmentGetRideAlongLinksParams
) => {
  return [
    `/api/Assignment/GetRideAlongLinks`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetRideAlongLinksQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetRideAlongLinksHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetRideAlongLinksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetRideAlongLinksHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssignmentGetRideAlongLinksQueryKey(params);

  const assignmentGetRideAlongLinks = useAssignmentGetRideAlongLinksHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetRideAlongLinksHook>>>
  > = ({ signal }) => assignmentGetRideAlongLinks(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetRideAlongLinksHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetRideAlongLinksQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetRideAlongLinksHook>>>
>;
export type AssignmentGetRideAlongLinksQueryError = unknown;

export const useAssignmentGetRideAlongLinks = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetRideAlongLinksHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetRideAlongLinksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetRideAlongLinksHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetRideAlongLinksQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetImportantHook = () => {
  const assignmentGetImportant = useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return assignmentGetImportant({
        url: `/api/Assignment/GetImportant`,
        method: 'GET',
        signal,
      });
    },
    [assignmentGetImportant]
  );
};

export const getAssignmentGetImportantQueryKey = () => {
  return [`/api/Assignment/GetImportant`] as const;
};

export const useAssignmentGetImportantQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAssignmentGetImportantHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetImportantHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssignmentGetImportantQueryKey();

  const assignmentGetImportant = useAssignmentGetImportantHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetImportantHook>>>
  > = ({ signal }) => assignmentGetImportant(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetImportantHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetImportantQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetImportantHook>>>
>;
export type AssignmentGetImportantQueryError = unknown;

export const useAssignmentGetImportant = <
  TData = Awaited<ReturnType<ReturnType<typeof useAssignmentGetImportantHook>>>,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetImportantHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetImportantQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetShouldGoOnTruckHook = () => {
  const assignmentGetShouldGoOnTruck =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return assignmentGetShouldGoOnTruck({
        url: `/api/Assignment/GetShouldGoOnTruck`,
        method: 'GET',
        signal,
      });
    },
    [assignmentGetShouldGoOnTruck]
  );
};

export const getAssignmentGetShouldGoOnTruckQueryKey = () => {
  return [`/api/Assignment/GetShouldGoOnTruck`] as const;
};

export const useAssignmentGetShouldGoOnTruckQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetShouldGoOnTruckHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetShouldGoOnTruckHook>>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssignmentGetShouldGoOnTruckQueryKey();

  const assignmentGetShouldGoOnTruck = useAssignmentGetShouldGoOnTruckHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetShouldGoOnTruckHook>>>
  > = ({ signal }) => assignmentGetShouldGoOnTruck(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetShouldGoOnTruckHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetShouldGoOnTruckQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetShouldGoOnTruckHook>>>
>;
export type AssignmentGetShouldGoOnTruckQueryError = unknown;

export const useAssignmentGetShouldGoOnTruck = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetShouldGoOnTruckHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentGetShouldGoOnTruckHook>>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetShouldGoOnTruckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook =
  () => {
    const assignmentFindPlannedAssignmentsToSendToFieldTestersCounts =
      useCustomInstance<AssignmentsToSendCountDto>();

    return useCallback(
      (
        findPlannedAssignmentsToSendToFieldTestersCountsRequest: FindPlannedAssignmentsToSendToFieldTestersCountsRequest
      ) => {
        return assignmentFindPlannedAssignmentsToSendToFieldTestersCounts({
          url: `/api/Assignment/FindPlannedAssignmentsToSendToFieldTestersCounts`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: findPlannedAssignmentsToSendToFieldTestersCountsRequest,
        });
      },
      [assignmentFindPlannedAssignmentsToSendToFieldTestersCounts]
    );
  };

export const useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook
          >
        >
      >,
      TError,
      { data: FindPlannedAssignmentsToSendToFieldTestersCountsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook
        >
      >
    >,
    TError,
    { data: FindPlannedAssignmentsToSendToFieldTestersCountsRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentFindPlannedAssignmentsToSendToFieldTestersCounts =
      useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook
          >
        >
      >,
      { data: FindPlannedAssignmentsToSendToFieldTestersCountsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentFindPlannedAssignmentsToSendToFieldTestersCounts(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentFindPlannedAssignmentsToSendToFieldTestersCountsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook
        >
      >
    >
  >;
export type AssignmentFindPlannedAssignmentsToSendToFieldTestersCountsMutationBody =
  FindPlannedAssignmentsToSendToFieldTestersCountsRequest;
export type AssignmentFindPlannedAssignmentsToSendToFieldTestersCountsMutationError =
  unknown;

export const useAssignmentFindPlannedAssignmentsToSendToFieldTestersCounts = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook
        >
      >
    >,
    TError,
    { data: FindPlannedAssignmentsToSendToFieldTestersCountsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsHook
      >
    >
  >,
  TError,
  { data: FindPlannedAssignmentsToSendToFieldTestersCountsRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentFindPlannedAssignmentsToSendToFieldTestersCountsMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
/**
 * @deprecated
 */
export const useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook =
  () => {
    const assignmentGetPlannedAssignmentsToSendToFieldTesters =
      useCustomInstance<number>();

    return useCallback(
      (
        params?: AssignmentGetPlannedAssignmentsToSendToFieldTestersParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetPlannedAssignmentsToSendToFieldTesters({
          url: `/api/Assignment/GetPlannedAssignmentsToSendToFieldTesters`,
          method: 'GET',
          params,
          signal,
        });
      },
      [assignmentGetPlannedAssignmentsToSendToFieldTesters]
    );
  };

export const getAssignmentGetPlannedAssignmentsToSendToFieldTestersQueryKey = (
  params?: AssignmentGetPlannedAssignmentsToSendToFieldTestersParams
) => {
  return [
    `/api/Assignment/GetPlannedAssignmentsToSendToFieldTesters`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetPlannedAssignmentsToSendToFieldTestersQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetPlannedAssignmentsToSendToFieldTestersParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetPlannedAssignmentsToSendToFieldTestersQueryKey(params);

    const assignmentGetPlannedAssignmentsToSendToFieldTesters =
      useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetPlannedAssignmentsToSendToFieldTesters(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetPlannedAssignmentsToSendToFieldTestersQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook
        >
      >
    >
  >;
export type AssignmentGetPlannedAssignmentsToSendToFieldTestersQueryError =
  unknown;

/**
 * @deprecated
 */
export const useAssignmentGetPlannedAssignmentsToSendToFieldTesters = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook
      >
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetPlannedAssignmentsToSendToFieldTestersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetPlannedAssignmentsToSendToFieldTestersHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetPlannedAssignmentsToSendToFieldTestersQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentSendPlannedAssignmentsToFieldTestersHook = () => {
  const assignmentSendPlannedAssignmentsToFieldTesters =
    useCustomInstance<boolean>();

  return useCallback(
    (
      sendPlannedAssignmentsToFieldTestersRequest: SendPlannedAssignmentsToFieldTestersRequest
    ) => {
      return assignmentSendPlannedAssignmentsToFieldTesters({
        url: `/api/Assignment/SendPlannedAssignmentsToFieldTesters`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: sendPlannedAssignmentsToFieldTestersRequest,
      });
    },
    [assignmentSendPlannedAssignmentsToFieldTesters]
  );
};

export const useAssignmentSendPlannedAssignmentsToFieldTestersMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentSendPlannedAssignmentsToFieldTestersHook
          >
        >
      >,
      TError,
      { data: SendPlannedAssignmentsToFieldTestersRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSendPlannedAssignmentsToFieldTestersHook>
      >
    >,
    TError,
    { data: SendPlannedAssignmentsToFieldTestersRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentSendPlannedAssignmentsToFieldTesters =
      useAssignmentSendPlannedAssignmentsToFieldTestersHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentSendPlannedAssignmentsToFieldTestersHook
          >
        >
      >,
      { data: SendPlannedAssignmentsToFieldTestersRequest }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentSendPlannedAssignmentsToFieldTesters(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentSendPlannedAssignmentsToFieldTestersMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSendPlannedAssignmentsToFieldTestersHook>
      >
    >
  >;
export type AssignmentSendPlannedAssignmentsToFieldTestersMutationBody =
  SendPlannedAssignmentsToFieldTestersRequest;
export type AssignmentSendPlannedAssignmentsToFieldTestersMutationError =
  unknown;

export const useAssignmentSendPlannedAssignmentsToFieldTesters = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSendPlannedAssignmentsToFieldTestersHook>
      >
    >,
    TError,
    { data: SendPlannedAssignmentsToFieldTestersRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSendPlannedAssignmentsToFieldTestersHook>
    >
  >,
  TError,
  { data: SendPlannedAssignmentsToFieldTestersRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentSendPlannedAssignmentsToFieldTestersMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentSendPlannedAssignmentsForUserHook = () => {
  const assignmentSendPlannedAssignmentsForUser =
    useCustomInstance<SendPlannedAssignmentsForUserResult>();

  return useCallback(
    (
      sendPlannedAssignmentsForUserRequest: SendPlannedAssignmentsForUserRequest
    ) => {
      return assignmentSendPlannedAssignmentsForUser({
        url: `/api/Assignment/SendPlannedAssignmentsForUser`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: sendPlannedAssignmentsForUserRequest,
      });
    },
    [assignmentSendPlannedAssignmentsForUser]
  );
};

export const useAssignmentSendPlannedAssignmentsForUserMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSendPlannedAssignmentsForUserHook>
      >
    >,
    TError,
    { data: SendPlannedAssignmentsForUserRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSendPlannedAssignmentsForUserHook>
    >
  >,
  TError,
  { data: SendPlannedAssignmentsForUserRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSendPlannedAssignmentsForUser =
    useAssignmentSendPlannedAssignmentsForUserHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSendPlannedAssignmentsForUserHook>
      >
    >,
    { data: SendPlannedAssignmentsForUserRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentSendPlannedAssignmentsForUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSendPlannedAssignmentsForUserMutationResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSendPlannedAssignmentsForUserHook>
    >
  >
>;
export type AssignmentSendPlannedAssignmentsForUserMutationBody =
  SendPlannedAssignmentsForUserRequest;
export type AssignmentSendPlannedAssignmentsForUserMutationError = unknown;

export const useAssignmentSendPlannedAssignmentsForUser = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSendPlannedAssignmentsForUserHook>
      >
    >,
    TError,
    { data: SendPlannedAssignmentsForUserRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSendPlannedAssignmentsForUserHook>
    >
  >,
  TError,
  { data: SendPlannedAssignmentsForUserRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentSendPlannedAssignmentsForUserMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetFollowUpAssignmentCandidatesHook = () => {
  const assignmentGetFollowUpAssignmentCandidates =
    useCustomInstance<ConnectedAssignmentsResponse>();

  return useCallback(
    (
      params?: AssignmentGetFollowUpAssignmentCandidatesParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetFollowUpAssignmentCandidates({
        url: `/api/Assignment/GetFollowUpAssignmentCandidates`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetFollowUpAssignmentCandidates]
  );
};

export const getAssignmentGetFollowUpAssignmentCandidatesQueryKey = (
  params?: AssignmentGetFollowUpAssignmentCandidatesParams
) => {
  return [
    `/api/Assignment/GetFollowUpAssignmentCandidates`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetFollowUpAssignmentCandidatesQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFollowUpAssignmentCandidatesHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetFollowUpAssignmentCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetFollowUpAssignmentCandidatesHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetFollowUpAssignmentCandidatesQueryKey(params);

  const assignmentGetFollowUpAssignmentCandidates =
    useAssignmentGetFollowUpAssignmentCandidatesHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFollowUpAssignmentCandidatesHook>
      >
    >
  > = ({ signal }) => assignmentGetFollowUpAssignmentCandidates(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetFollowUpAssignmentCandidatesHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetFollowUpAssignmentCandidatesQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFollowUpAssignmentCandidatesHook>
    >
  >
>;
export type AssignmentGetFollowUpAssignmentCandidatesQueryError = unknown;

export const useAssignmentGetFollowUpAssignmentCandidates = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetFollowUpAssignmentCandidatesHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetFollowUpAssignmentCandidatesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetFollowUpAssignmentCandidatesHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetFollowUpAssignmentCandidatesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentSetAssignmentToFollowUpHook = () => {
  const assignmentSetAssignmentToFollowUp = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentSetAssignmentToFollowUpParams) => {
      return assignmentSetAssignmentToFollowUp({
        url: `/api/Assignment/SetAssignmentToFollowUp`,
        method: 'POST',
        params,
      });
    },
    [assignmentSetAssignmentToFollowUp]
  );
};

export const useAssignmentSetAssignmentToFollowUpMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSetAssignmentToFollowUpHook>>
    >,
    TError,
    { params?: AssignmentSetAssignmentToFollowUpParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSetAssignmentToFollowUpHook>>
  >,
  TError,
  { params?: AssignmentSetAssignmentToFollowUpParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentSetAssignmentToFollowUp =
    useAssignmentSetAssignmentToFollowUpHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSetAssignmentToFollowUpHook>>
    >,
    { params?: AssignmentSetAssignmentToFollowUpParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentSetAssignmentToFollowUp(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentSetAssignmentToFollowUpMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSetAssignmentToFollowUpHook>>
  >
>;

export type AssignmentSetAssignmentToFollowUpMutationError = unknown;

export const useAssignmentSetAssignmentToFollowUp = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentSetAssignmentToFollowUpHook>>
    >,
    TError,
    { params?: AssignmentSetAssignmentToFollowUpParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentSetAssignmentToFollowUpHook>>
  >,
  TError,
  { params?: AssignmentSetAssignmentToFollowUpParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentSetAssignmentToFollowUpMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentSortFieldTestersForNewAssignmentHook = () => {
  const assignmentSortFieldTestersForNewAssignment =
    useCustomInstance<SortResult>();

  return useCallback(
    (
      params?: AssignmentSortFieldTestersForNewAssignmentParams,
      signal?: AbortSignal
    ) => {
      return assignmentSortFieldTestersForNewAssignment({
        url: `/api/Assignment/SortFieldTestersForNewAssignment`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentSortFieldTestersForNewAssignment]
  );
};

export const getAssignmentSortFieldTestersForNewAssignmentQueryKey = (
  params?: AssignmentSortFieldTestersForNewAssignmentParams
) => {
  return [
    `/api/Assignment/SortFieldTestersForNewAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentSortFieldTestersForNewAssignmentQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSortFieldTestersForNewAssignmentHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentSortFieldTestersForNewAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentSortFieldTestersForNewAssignmentHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentSortFieldTestersForNewAssignmentQueryKey(params);

  const assignmentSortFieldTestersForNewAssignment =
    useAssignmentSortFieldTestersForNewAssignmentHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSortFieldTestersForNewAssignmentHook>
      >
    >
  > = ({ signal }) =>
    assignmentSortFieldTestersForNewAssignment(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentSortFieldTestersForNewAssignmentHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentSortFieldTestersForNewAssignmentQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSortFieldTestersForNewAssignmentHook>
    >
  >
>;
export type AssignmentSortFieldTestersForNewAssignmentQueryError = unknown;

export const useAssignmentSortFieldTestersForNewAssignment = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentSortFieldTestersForNewAssignmentHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentSortFieldTestersForNewAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentSortFieldTestersForNewAssignmentHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentSortFieldTestersForNewAssignmentQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentExecutePredefinedActionHook = () => {
  const assignmentExecutePredefinedAction = useCustomInstance<void>();

  return useCallback(
    (
      assignmentModel: AssignmentModel,
      params?: AssignmentExecutePredefinedActionParams
    ) => {
      return assignmentExecutePredefinedAction({
        url: `/api/Assignment/ExecutePredefinedAction`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignmentModel,
        params,
      });
    },
    [assignmentExecutePredefinedAction]
  );
};

export const useAssignmentExecutePredefinedActionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentExecutePredefinedActionHook>>
    >,
    TError,
    { data: AssignmentModel; params?: AssignmentExecutePredefinedActionParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentExecutePredefinedActionHook>>
  >,
  TError,
  { data: AssignmentModel; params?: AssignmentExecutePredefinedActionParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentExecutePredefinedAction =
    useAssignmentExecutePredefinedActionHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentExecutePredefinedActionHook>>
    >,
    { data: AssignmentModel; params?: AssignmentExecutePredefinedActionParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return assignmentExecutePredefinedAction(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentExecutePredefinedActionMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentExecutePredefinedActionHook>>
  >
>;
export type AssignmentExecutePredefinedActionMutationBody = AssignmentModel;
export type AssignmentExecutePredefinedActionMutationError = unknown;

export const useAssignmentExecutePredefinedAction = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentExecutePredefinedActionHook>>
    >,
    TError,
    { data: AssignmentModel; params?: AssignmentExecutePredefinedActionParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentExecutePredefinedActionHook>>
  >,
  TError,
  { data: AssignmentModel; params?: AssignmentExecutePredefinedActionParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentExecutePredefinedActionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentAddStandardizedCommentHook = () => {
  const assignmentAddStandardizedComment = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentAddStandardizedCommentParams) => {
      return assignmentAddStandardizedComment({
        url: `/api/Assignment/AddStandardizedComment`,
        method: 'POST',
        params,
      });
    },
    [assignmentAddStandardizedComment]
  );
};

export const useAssignmentAddStandardizedCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentAddStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentAddStandardizedCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentAddStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentAddStandardizedCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentAddStandardizedComment =
    useAssignmentAddStandardizedCommentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentAddStandardizedCommentHook>>
    >,
    { params?: AssignmentAddStandardizedCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentAddStandardizedComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentAddStandardizedCommentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentAddStandardizedCommentHook>>
  >
>;

export type AssignmentAddStandardizedCommentMutationError = unknown;

export const useAssignmentAddStandardizedComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentAddStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentAddStandardizedCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentAddStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentAddStandardizedCommentParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentAddStandardizedCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentRemoveStandardizedCommentHook = () => {
  const assignmentRemoveStandardizedComment = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentRemoveStandardizedCommentParams) => {
      return assignmentRemoveStandardizedComment({
        url: `/api/Assignment/RemoveStandardizedComment`,
        method: 'POST',
        params,
      });
    },
    [assignmentRemoveStandardizedComment]
  );
};

export const useAssignmentRemoveStandardizedCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRemoveStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentRemoveStandardizedCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRemoveStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentRemoveStandardizedCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentRemoveStandardizedComment =
    useAssignmentRemoveStandardizedCommentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRemoveStandardizedCommentHook>>
    >,
    { params?: AssignmentRemoveStandardizedCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentRemoveStandardizedComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentRemoveStandardizedCommentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRemoveStandardizedCommentHook>>
  >
>;

export type AssignmentRemoveStandardizedCommentMutationError = unknown;

export const useAssignmentRemoveStandardizedComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRemoveStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentRemoveStandardizedCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRemoveStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentRemoveStandardizedCommentParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentRemoveStandardizedCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentCreateStandardizedCommentHook = () => {
  const assignmentCreateStandardizedComment = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentCreateStandardizedCommentParams) => {
      return assignmentCreateStandardizedComment({
        url: `/api/Assignment/CreateStandardizedComment`,
        method: 'POST',
        params,
      });
    },
    [assignmentCreateStandardizedComment]
  );
};

export const useAssignmentCreateStandardizedCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentCreateStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentCreateStandardizedCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentCreateStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentCreateStandardizedCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentCreateStandardizedComment =
    useAssignmentCreateStandardizedCommentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentCreateStandardizedCommentHook>>
    >,
    { params?: AssignmentCreateStandardizedCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentCreateStandardizedComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentCreateStandardizedCommentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentCreateStandardizedCommentHook>>
  >
>;

export type AssignmentCreateStandardizedCommentMutationError = unknown;

export const useAssignmentCreateStandardizedComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentCreateStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentCreateStandardizedCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentCreateStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentCreateStandardizedCommentParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentCreateStandardizedCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAllDetailedStandardizedCommentsHook = () => {
  const assignmentGetAllDetailedStandardizedComments =
    useCustomInstance<DetailedStandardizedCommentDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return assignmentGetAllDetailedStandardizedComments({
        url: `/api/Assignment/GetAllDetailedStandardizedComments`,
        method: 'GET',
        signal,
      });
    },
    [assignmentGetAllDetailedStandardizedComments]
  );
};

export const getAssignmentGetAllDetailedStandardizedCommentsQueryKey = () => {
  return [`/api/Assignment/GetAllDetailedStandardizedComments`] as const;
};

export const useAssignmentGetAllDetailedStandardizedCommentsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAllDetailedStandardizedCommentsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAllDetailedStandardizedCommentsHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAllDetailedStandardizedCommentsQueryKey();

  const assignmentGetAllDetailedStandardizedComments =
    useAssignmentGetAllDetailedStandardizedCommentsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAllDetailedStandardizedCommentsHook>
      >
    >
  > = ({ signal }) => assignmentGetAllDetailedStandardizedComments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAllDetailedStandardizedCommentsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAllDetailedStandardizedCommentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAllDetailedStandardizedCommentsHook>
      >
    >
  >;
export type AssignmentGetAllDetailedStandardizedCommentsQueryError = unknown;

export const useAssignmentGetAllDetailedStandardizedComments = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAllDetailedStandardizedCommentsHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAllDetailedStandardizedCommentsHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAllDetailedStandardizedCommentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentDeleteStandardizedCommentHook = () => {
  const assignmentDeleteStandardizedComment = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentDeleteStandardizedCommentParams) => {
      return assignmentDeleteStandardizedComment({
        url: `/api/Assignment/DeleteStandardizedComment`,
        method: 'DELETE',
        params,
      });
    },
    [assignmentDeleteStandardizedComment]
  );
};

export const useAssignmentDeleteStandardizedCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentDeleteStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentDeleteStandardizedCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDeleteStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentDeleteStandardizedCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentDeleteStandardizedComment =
    useAssignmentDeleteStandardizedCommentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentDeleteStandardizedCommentHook>>
    >,
    { params?: AssignmentDeleteStandardizedCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentDeleteStandardizedComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentDeleteStandardizedCommentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDeleteStandardizedCommentHook>>
  >
>;

export type AssignmentDeleteStandardizedCommentMutationError = unknown;

export const useAssignmentDeleteStandardizedComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentDeleteStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentDeleteStandardizedCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentDeleteStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentDeleteStandardizedCommentParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentDeleteStandardizedCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentUpdateStandardizedCommentHook = () => {
  const assignmentUpdateStandardizedComment = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentUpdateStandardizedCommentParams) => {
      return assignmentUpdateStandardizedComment({
        url: `/api/Assignment/UpdateStandardizedComment`,
        method: 'POST',
        params,
      });
    },
    [assignmentUpdateStandardizedComment]
  );
};

export const useAssignmentUpdateStandardizedCommentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentUpdateStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentUpdateStandardizedCommentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentUpdateStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentUpdateStandardizedCommentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentUpdateStandardizedComment =
    useAssignmentUpdateStandardizedCommentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentUpdateStandardizedCommentHook>>
    >,
    { params?: AssignmentUpdateStandardizedCommentParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentUpdateStandardizedComment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentUpdateStandardizedCommentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentUpdateStandardizedCommentHook>>
  >
>;

export type AssignmentUpdateStandardizedCommentMutationError = unknown;

export const useAssignmentUpdateStandardizedComment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentUpdateStandardizedCommentHook>>
    >,
    TError,
    { params?: AssignmentUpdateStandardizedCommentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentUpdateStandardizedCommentHook>>
  >,
  TError,
  { params?: AssignmentUpdateStandardizedCommentParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentUpdateStandardizedCommentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentApproveSuggestionHook = () => {
  const assignmentApproveSuggestion = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentApproveSuggestionParams) => {
      return assignmentApproveSuggestion({
        url: `/api/Assignment/ApproveSuggestion`,
        method: 'POST',
        params,
      });
    },
    [assignmentApproveSuggestion]
  );
};

export const useAssignmentApproveSuggestionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentApproveSuggestionHook>>>,
    TError,
    { params?: AssignmentApproveSuggestionParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentApproveSuggestionHook>>>,
  TError,
  { params?: AssignmentApproveSuggestionParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentApproveSuggestion = useAssignmentApproveSuggestionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentApproveSuggestionHook>>>,
    { params?: AssignmentApproveSuggestionParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentApproveSuggestion(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentApproveSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentApproveSuggestionHook>>>
>;

export type AssignmentApproveSuggestionMutationError = unknown;

export const useAssignmentApproveSuggestion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentApproveSuggestionHook>>>,
    TError,
    { params?: AssignmentApproveSuggestionParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentApproveSuggestionHook>>>,
  TError,
  { params?: AssignmentApproveSuggestionParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentApproveSuggestionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentRejectSuggestionHook = () => {
  const assignmentRejectSuggestion = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentRejectSuggestionParams) => {
      return assignmentRejectSuggestion({
        url: `/api/Assignment/RejectSuggestion`,
        method: 'POST',
        params,
      });
    },
    [assignmentRejectSuggestion]
  );
};

export const useAssignmentRejectSuggestionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentRejectSuggestionHook>>>,
    TError,
    { params?: AssignmentRejectSuggestionParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentRejectSuggestionHook>>>,
  TError,
  { params?: AssignmentRejectSuggestionParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentRejectSuggestion = useAssignmentRejectSuggestionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentRejectSuggestionHook>>>,
    { params?: AssignmentRejectSuggestionParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentRejectSuggestion(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentRejectSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentRejectSuggestionHook>>>
>;

export type AssignmentRejectSuggestionMutationError = unknown;

export const useAssignmentRejectSuggestion = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentRejectSuggestionHook>>>,
    TError,
    { params?: AssignmentRejectSuggestionParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentRejectSuggestionHook>>>,
  TError,
  { params?: AssignmentRejectSuggestionParams },
  TContext
> => {
  const mutationOptions = useAssignmentRejectSuggestionMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentLeaveDeviationReportHook = () => {
  const assignmentLeaveDeviationReport = useCustomInstance<void>();

  return useCallback(
    (deviationReportRequest: DeviationReportRequest) => {
      return assignmentLeaveDeviationReport({
        url: `/api/Assignment/LeaveDeviationReport`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: deviationReportRequest,
      });
    },
    [assignmentLeaveDeviationReport]
  );
};

export const useAssignmentLeaveDeviationReportMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentLeaveDeviationReportHook>>
    >,
    TError,
    { data: DeviationReportRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentLeaveDeviationReportHook>>>,
  TError,
  { data: DeviationReportRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentLeaveDeviationReport =
    useAssignmentLeaveDeviationReportHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentLeaveDeviationReportHook>>
    >,
    { data: DeviationReportRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentLeaveDeviationReport(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentLeaveDeviationReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentLeaveDeviationReportHook>>>
>;
export type AssignmentLeaveDeviationReportMutationBody = DeviationReportRequest;
export type AssignmentLeaveDeviationReportMutationError = unknown;

export const useAssignmentLeaveDeviationReport = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentLeaveDeviationReportHook>>
    >,
    TError,
    { data: DeviationReportRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentLeaveDeviationReportHook>>>,
  TError,
  { data: DeviationReportRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentLeaveDeviationReportMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAssignmentRequestsHook = () => {
  const assignmentGetAssignmentRequests = useCustomInstance<EventModel[]>();

  return useCallback(
    (params?: AssignmentGetAssignmentRequestsParams, signal?: AbortSignal) => {
      return assignmentGetAssignmentRequests({
        url: `/api/Assignment/GetAssignmentRequests`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAssignmentRequests]
  );
};

export const getAssignmentGetAssignmentRequestsQueryKey = (
  params?: AssignmentGetAssignmentRequestsParams
) => {
  return [
    `/api/Assignment/GetAssignmentRequests`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAssignmentRequestsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAssignmentRequestsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAssignmentRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetAssignmentRequestsHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAssignmentRequestsQueryKey(params);

  const assignmentGetAssignmentRequests =
    useAssignmentGetAssignmentRequestsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAssignmentRequestsHook>>
    >
  > = ({ signal }) => assignmentGetAssignmentRequests(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAssignmentRequestsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAssignmentRequestsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentGetAssignmentRequestsHook>>>
>;
export type AssignmentGetAssignmentRequestsQueryError = unknown;

export const useAssignmentGetAssignmentRequests = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAssignmentRequestsHook>>
  >,
  TError = unknown,
>(
  params?: AssignmentGetAssignmentRequestsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useAssignmentGetAssignmentRequestsHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useAssignmentGetAssignmentRequestsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook = () => {
  const assignmentMarkAssignmentInNeedOfHandlingAsHandled =
    useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentMarkAssignmentInNeedOfHandlingAsHandledParams) => {
      return assignmentMarkAssignmentInNeedOfHandlingAsHandled({
        url: `/api/Assignment/MarkAssignmentInNeedOfHandlingAsHandled`,
        method: 'POST',
        params,
      });
    },
    [assignmentMarkAssignmentInNeedOfHandlingAsHandled]
  );
};

export const useAssignmentMarkAssignmentInNeedOfHandlingAsHandledMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook
          >
        >
      >,
      TError,
      { params?: AssignmentMarkAssignmentInNeedOfHandlingAsHandledParams },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook
        >
      >
    >,
    TError,
    { params?: AssignmentMarkAssignmentInNeedOfHandlingAsHandledParams },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentMarkAssignmentInNeedOfHandlingAsHandled =
      useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook
          >
        >
      >,
      { params?: AssignmentMarkAssignmentInNeedOfHandlingAsHandledParams }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentMarkAssignmentInNeedOfHandlingAsHandled(params);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentMarkAssignmentInNeedOfHandlingAsHandledMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook
        >
      >
    >
  >;

export type AssignmentMarkAssignmentInNeedOfHandlingAsHandledMutationError =
  unknown;

export const useAssignmentMarkAssignmentInNeedOfHandlingAsHandled = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook
        >
      >
    >,
    TError,
    { params?: AssignmentMarkAssignmentInNeedOfHandlingAsHandledParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentMarkAssignmentInNeedOfHandlingAsHandledHook
      >
    >
  >,
  TError,
  { params?: AssignmentMarkAssignmentInNeedOfHandlingAsHandledParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentMarkAssignmentInNeedOfHandlingAsHandledMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook =
  () => {
    const assignmentGetPurchaseAssignmentsForSameAddressAndBookedToTime =
      useCustomInstance<AssignmentViewModel[]>();

    return useCallback(
      (assignmentDataLookupRecord: AssignmentDataLookupRecord) => {
        return assignmentGetPurchaseAssignmentsForSameAddressAndBookedToTime({
          url: `/api/Assignment/GetPurchaseAssignmentsForSameAddressAndBookedToTime`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: assignmentDataLookupRecord,
        });
      },
      [assignmentGetPurchaseAssignmentsForSameAddressAndBookedToTime]
    );
  };

export const useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook
          >
        >
      >,
      TError,
      { data: AssignmentDataLookupRecord },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook
        >
      >
    >,
    TError,
    { data: AssignmentDataLookupRecord },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentGetPurchaseAssignmentsForSameAddressAndBookedToTime =
      useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook
          >
        >
      >,
      { data: AssignmentDataLookupRecord }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentGetPurchaseAssignmentsForSameAddressAndBookedToTime(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook
        >
      >
    >
  >;
export type AssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeMutationBody =
  AssignmentDataLookupRecord;
export type AssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeMutationError =
  unknown;

export const useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTime =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook
          >
        >
      >,
      TError,
      { data: AssignmentDataLookupRecord },
      TContext
    >;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeHook
        >
      >
    >,
    TError,
    { data: AssignmentDataLookupRecord },
    TContext
  > => {
    const mutationOptions =
      useAssignmentGetPurchaseAssignmentsForSameAddressAndBookedToTimeMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };
export const useAssignmentAutoApproveAssignmentsHook = () => {
  const assignmentAutoApproveAssignments = useCustomInstance<void>();

  return useCallback(() => {
    return assignmentAutoApproveAssignments({
      url: `/api/Assignment/AutoApproveAssignments`,
      method: 'POST',
    });
  }, [assignmentAutoApproveAssignments]);
};

export const useAssignmentAutoApproveAssignmentsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentAutoApproveAssignmentsHook>>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentAutoApproveAssignmentsHook>>
  >,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentAutoApproveAssignments =
    useAssignmentAutoApproveAssignmentsHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentAutoApproveAssignmentsHook>>
    >,
    void
  > = () => {
    return assignmentAutoApproveAssignments();
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentAutoApproveAssignmentsMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentAutoApproveAssignmentsHook>>
  >
>;

export type AssignmentAutoApproveAssignmentsMutationError = unknown;

export const useAssignmentAutoApproveAssignments = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentAutoApproveAssignmentsHook>>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentAutoApproveAssignmentsHook>>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useAssignmentAutoApproveAssignmentsMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentRunAutoApproveRoutineHook = () => {
  const assignmentRunAutoApproveRoutine = useCustomInstance<number>();

  return useCallback(() => {
    return assignmentRunAutoApproveRoutine({
      url: `/api/Assignment/RunAutoApproveRoutine`,
      method: 'POST',
    });
  }, [assignmentRunAutoApproveRoutine]);
};

export const useAssignmentRunAutoApproveRoutineMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRunAutoApproveRoutineHook>>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRunAutoApproveRoutineHook>>
  >,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentRunAutoApproveRoutine =
    useAssignmentRunAutoApproveRoutineHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRunAutoApproveRoutineHook>>
    >,
    void
  > = () => {
    return assignmentRunAutoApproveRoutine();
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentRunAutoApproveRoutineMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentRunAutoApproveRoutineHook>>>
>;

export type AssignmentRunAutoApproveRoutineMutationError = unknown;

export const useAssignmentRunAutoApproveRoutine = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentRunAutoApproveRoutineHook>>
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentRunAutoApproveRoutineHook>>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useAssignmentRunAutoApproveRoutineMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetAutoApproveLastRunAtHook = () => {
  const assignmentGetAutoApproveLastRunAt = useCustomInstance<Date>();

  return useCallback(
    (signal?: AbortSignal) => {
      return assignmentGetAutoApproveLastRunAt({
        url: `/api/Assignment/GetAutoApproveLastRunAt`,
        method: 'GET',
        signal,
      });
    },
    [assignmentGetAutoApproveLastRunAt]
  );
};

export const getAssignmentGetAutoApproveLastRunAtQueryKey = () => {
  return [`/api/Assignment/GetAutoApproveLastRunAt`] as const;
};

export const useAssignmentGetAutoApproveLastRunAtQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveLastRunAtHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveLastRunAtHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAssignmentGetAutoApproveLastRunAtQueryKey();

  const assignmentGetAutoApproveLastRunAt =
    useAssignmentGetAutoApproveLastRunAtHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveLastRunAtHook>>
    >
  > = ({ signal }) => assignmentGetAutoApproveLastRunAt(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveLastRunAtHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveLastRunAtQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveLastRunAtHook>>
  >
>;
export type AssignmentGetAutoApproveLastRunAtQueryError = unknown;

export const useAssignmentGetAutoApproveLastRunAt = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useAssignmentGetAutoApproveLastRunAtHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useAssignmentGetAutoApproveLastRunAtHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAutoApproveLastRunAtQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook =
  () => {
    const assignmentGetCarTransportTruckAssignmentsWithDetailsForDate =
      useCustomInstance<ActiveCarTransportTruckDTO[]>();

    return useCallback(
      (
        params?: AssignmentGetCarTransportTruckAssignmentsWithDetailsForDateParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetCarTransportTruckAssignmentsWithDetailsForDate({
          url: `/api/Assignment/GetCarTransportTruckAssignmentsWithDetailsForDate`,
          method: 'GET',
          params,
          signal,
        });
      },
      [assignmentGetCarTransportTruckAssignmentsWithDetailsForDate]
    );
  };

export const getAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateQueryKey =
  (
    params?: AssignmentGetCarTransportTruckAssignmentsWithDetailsForDateParams
  ) => {
    return [
      `/api/Assignment/GetCarTransportTruckAssignmentsWithDetailsForDate`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetCarTransportTruckAssignmentsWithDetailsForDateParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateQueryKey(
        params
      );

    const assignmentGetCarTransportTruckAssignmentsWithDetailsForDate =
      useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetCarTransportTruckAssignmentsWithDetailsForDate(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetCarTransportTruckAssignmentsWithDetailsForDateQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook
        >
      >
    >
  >;
export type AssignmentGetCarTransportTruckAssignmentsWithDetailsForDateQueryError =
  unknown;

export const useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDate = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook
      >
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetCarTransportTruckAssignmentsWithDetailsForDateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetCarTransportTruckAssignmentsWithDetailsForDateQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAutoApproveAssignmentsCountHook = () => {
  const assignmentGetAutoApproveAssignmentsCount = useCustomInstance<number>();

  return useCallback(
    (signal?: AbortSignal) => {
      return assignmentGetAutoApproveAssignmentsCount({
        url: `/api/Assignment/GetAutoApproveAssignmentsCount`,
        method: 'GET',
        signal,
      });
    },
    [assignmentGetAutoApproveAssignmentsCount]
  );
};

export const getAssignmentGetAutoApproveAssignmentsCountQueryKey = () => {
  return [`/api/Assignment/GetAutoApproveAssignmentsCount`] as const;
};

export const useAssignmentGetAutoApproveAssignmentsCountQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveAssignmentsCountHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveAssignmentsCountHook>
      >
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAutoApproveAssignmentsCountQueryKey();

  const assignmentGetAutoApproveAssignmentsCount =
    useAssignmentGetAutoApproveAssignmentsCountHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveAssignmentsCountHook>
      >
    >
  > = ({ signal }) => assignmentGetAutoApproveAssignmentsCount(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveAssignmentsCountHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAutoApproveAssignmentsCountQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveAssignmentsCountHook>
    >
  >
>;
export type AssignmentGetAutoApproveAssignmentsCountQueryError = unknown;

export const useAssignmentGetAutoApproveAssignmentsCount = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAutoApproveAssignmentsCountHook>
    >
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAutoApproveAssignmentsCountHook>
      >
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAutoApproveAssignmentsCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAssignmentsForUserAndTimePeriodHook = () => {
  const assignmentGetAssignmentsForUserAndTimePeriod =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (
      params?: AssignmentGetAssignmentsForUserAndTimePeriodParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAssignmentsForUserAndTimePeriod({
        url: `/api/Assignment/GetAssignmentsForUserAndTimePeriod`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAssignmentsForUserAndTimePeriod]
  );
};

export const getAssignmentGetAssignmentsForUserAndTimePeriodQueryKey = (
  params?: AssignmentGetAssignmentsForUserAndTimePeriodParams
) => {
  return [
    `/api/Assignment/GetAssignmentsForUserAndTimePeriod`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAssignmentsForUserAndTimePeriodQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsForUserAndTimePeriodHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAssignmentsForUserAndTimePeriodParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAssignmentsForUserAndTimePeriodHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAssignmentsForUserAndTimePeriodQueryKey(params);

  const assignmentGetAssignmentsForUserAndTimePeriod =
    useAssignmentGetAssignmentsForUserAndTimePeriodHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsForUserAndTimePeriodHook>
      >
    >
  > = ({ signal }) =>
    assignmentGetAssignmentsForUserAndTimePeriod(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsForUserAndTimePeriodHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAssignmentsForUserAndTimePeriodQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsForUserAndTimePeriodHook>
      >
    >
  >;
export type AssignmentGetAssignmentsForUserAndTimePeriodQueryError = unknown;

export const useAssignmentGetAssignmentsForUserAndTimePeriod = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsForUserAndTimePeriodHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAssignmentsForUserAndTimePeriodParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAssignmentsForUserAndTimePeriodHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAssignmentsForUserAndTimePeriodQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAssignmentsForMeAndTimePeriodHook = () => {
  const assignmentGetAssignmentsForMeAndTimePeriod =
    useCustomInstance<AssignmentViewModel[]>();

  return useCallback(
    (
      params?: AssignmentGetAssignmentsForMeAndTimePeriodParams,
      signal?: AbortSignal
    ) => {
      return assignmentGetAssignmentsForMeAndTimePeriod({
        url: `/api/Assignment/GetAssignmentsForMeAndTimePeriod`,
        method: 'GET',
        params,
        signal,
      });
    },
    [assignmentGetAssignmentsForMeAndTimePeriod]
  );
};

export const getAssignmentGetAssignmentsForMeAndTimePeriodQueryKey = (
  params?: AssignmentGetAssignmentsForMeAndTimePeriodParams
) => {
  return [
    `/api/Assignment/GetAssignmentsForMeAndTimePeriod`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetAssignmentsForMeAndTimePeriodQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsForMeAndTimePeriodHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAssignmentsForMeAndTimePeriodParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAssignmentsForMeAndTimePeriodHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAssignmentGetAssignmentsForMeAndTimePeriodQueryKey(params);

  const assignmentGetAssignmentsForMeAndTimePeriod =
    useAssignmentGetAssignmentsForMeAndTimePeriodHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsForMeAndTimePeriodHook>
      >
    >
  > = ({ signal }) =>
    assignmentGetAssignmentsForMeAndTimePeriod(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentGetAssignmentsForMeAndTimePeriodHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AssignmentGetAssignmentsForMeAndTimePeriodQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsForMeAndTimePeriodHook>
    >
  >
>;
export type AssignmentGetAssignmentsForMeAndTimePeriodQueryError = unknown;

export const useAssignmentGetAssignmentsForMeAndTimePeriod = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentGetAssignmentsForMeAndTimePeriodHook>
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetAssignmentsForMeAndTimePeriodParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useAssignmentGetAssignmentsForMeAndTimePeriodHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetAssignmentsForMeAndTimePeriodQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook =
  () => {
    const assignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriod =
      useCustomInstance<AssignmentOrAssignmentRequestDto[]>();

    return useCallback(
      (
        params?: AssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriod({
          url: `/api/Assignment/GetAssignmentsAndAssignmentRequestsForMeAndTimePeriod`,
          method: 'GET',
          params,
          signal,
        });
      },
      [assignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriod]
    );
  };

export const getAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodQueryKey =
  (
    params?: AssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodParams
  ) => {
    return [
      `/api/Assignment/GetAssignmentsAndAssignmentRequestsForMeAndTimePeriod`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodQueryKey(
        params
      );

    const assignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriod =
      useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriod(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook
        >
      >
    >
  >;
export type AssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodQueryError =
  unknown;

export const useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriod =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      useAssignmentGetAssignmentsAndAssignmentRequestsForMeAndTimePeriodQueryOptions(
        params,
        options
      );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
  };

export const useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook =
  () => {
    const assignmentAssignRegularAssignmentToCarTransportTruckAssignment =
      useCustomInstance<void>();

    return useCallback(
      (
        params?: AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentParams
      ) => {
        return assignmentAssignRegularAssignmentToCarTransportTruckAssignment({
          url: `/api/Assignment/AssignRegularAssignmentToCarTransportTruckAssignment`,
          method: 'POST',
          params,
        });
      },
      [assignmentAssignRegularAssignmentToCarTransportTruckAssignment]
    );
  };

export const useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentAssignRegularAssignmentToCarTransportTruckAssignment =
      useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook
          >
        >
      >,
      {
        params?: AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentAssignRegularAssignmentToCarTransportTruckAssignment(
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook
        >
      >
    >
  >;

export type AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentMutationError =
  unknown;

export const useAssignmentAssignRegularAssignmentToCarTransportTruckAssignment =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentParams;
      },
      TContext
    >;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentAssignRegularAssignmentToCarTransportTruckAssignmentParams;
    },
    TContext
  > => {
    const mutationOptions =
      useAssignmentAssignRegularAssignmentToCarTransportTruckAssignmentMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };
export const useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook =
  () => {
    const assignmentUnassignRegularAssignmentFromCarTransportTruckAssignment =
      useCustomInstance<void>();

    return useCallback(
      (
        params?: AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentParams
      ) => {
        return assignmentUnassignRegularAssignmentFromCarTransportTruckAssignment(
          {
            url: `/api/Assignment/UnassignRegularAssignmentFromCarTransportTruckAssignment`,
            method: 'POST',
            params,
          }
        );
      },
      [assignmentUnassignRegularAssignmentFromCarTransportTruckAssignment]
    );
  };

export const useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentUnassignRegularAssignmentFromCarTransportTruckAssignment =
      useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook
          >
        >
      >,
      {
        params?: AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentUnassignRegularAssignmentFromCarTransportTruckAssignment(
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook
        >
      >
    >
  >;

export type AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentMutationError =
  unknown;

export const useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignment =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentParams;
      },
      TContext
    >;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentParams;
    },
    TContext
  > => {
    const mutationOptions =
      useAssignmentUnassignRegularAssignmentFromCarTransportTruckAssignmentMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };
export const useAssignmentReplacePlaceholderAssignmentHook = () => {
  const assignmentReplacePlaceholderAssignment = useCustomInstance<void>();

  return useCallback(
    (params?: AssignmentReplacePlaceholderAssignmentParams) => {
      return assignmentReplacePlaceholderAssignment({
        url: `/api/Assignment/ReplacePlaceholderAssignment`,
        method: 'POST',
        params,
      });
    },
    [assignmentReplacePlaceholderAssignment]
  );
};

export const useAssignmentReplacePlaceholderAssignmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentReplacePlaceholderAssignmentHook>
      >
    >,
    TError,
    { params?: AssignmentReplacePlaceholderAssignmentParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentReplacePlaceholderAssignmentHook>>
  >,
  TError,
  { params?: AssignmentReplacePlaceholderAssignmentParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentReplacePlaceholderAssignment =
    useAssignmentReplacePlaceholderAssignmentHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentReplacePlaceholderAssignmentHook>
      >
    >,
    { params?: AssignmentReplacePlaceholderAssignmentParams }
  > = (props) => {
    const { params } = props ?? {};

    return assignmentReplacePlaceholderAssignment(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentReplacePlaceholderAssignmentMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentReplacePlaceholderAssignmentHook>>
  >
>;

export type AssignmentReplacePlaceholderAssignmentMutationError = unknown;

export const useAssignmentReplacePlaceholderAssignment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentReplacePlaceholderAssignmentHook>
      >
    >,
    TError,
    { params?: AssignmentReplacePlaceholderAssignmentParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentReplacePlaceholderAssignmentHook>>
  >,
  TError,
  { params?: AssignmentReplacePlaceholderAssignmentParams },
  TContext
> => {
  const mutationOptions =
    useAssignmentReplacePlaceholderAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook =
  () => {
    const assignmentGetCarTransportTruckAssignmentsForAssignment =
      useCustomInstance<TransportAssignmentModel[]>();

    return useCallback(
      (
        params?: AssignmentGetCarTransportTruckAssignmentsForAssignmentParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetCarTransportTruckAssignmentsForAssignment({
          url: `/api/Assignment/GetCarTransportTruckAssignmentsForAssignment`,
          method: 'GET',
          params,
          signal,
        });
      },
      [assignmentGetCarTransportTruckAssignmentsForAssignment]
    );
  };

export const getAssignmentGetCarTransportTruckAssignmentsForAssignmentQueryKey =
  (params?: AssignmentGetCarTransportTruckAssignmentsForAssignmentParams) => {
    return [
      `/api/Assignment/GetCarTransportTruckAssignmentsForAssignment`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useAssignmentGetCarTransportTruckAssignmentsForAssignmentQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetCarTransportTruckAssignmentsForAssignmentParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetCarTransportTruckAssignmentsForAssignmentQueryKey(params);

    const assignmentGetCarTransportTruckAssignmentsForAssignment =
      useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetCarTransportTruckAssignmentsForAssignment(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetCarTransportTruckAssignmentsForAssignmentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook
        >
      >
    >
  >;
export type AssignmentGetCarTransportTruckAssignmentsForAssignmentQueryError =
  unknown;

export const useAssignmentGetCarTransportTruckAssignmentsForAssignment = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook
      >
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetCarTransportTruckAssignmentsForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetCarTransportTruckAssignmentsForAssignmentHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetCarTransportTruckAssignmentsForAssignmentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook =
  () => {
    const assignmentGetAssignedAssignmentsForCarTransportTruckAssignment =
      useCustomInstance<TransportAssignmentModel[]>();

    return useCallback(
      (
        params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetAssignedAssignmentsForCarTransportTruckAssignment({
          url: `/api/Assignment/GetAssignedAssignmentsForCarTransportTruckAssignment`,
          method: 'GET',
          params,
          signal,
        });
      },
      [assignmentGetAssignedAssignmentsForCarTransportTruckAssignment]
    );
  };

export const getAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentQueryKey =
  (
    params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentParams
  ) => {
    return [
      `/api/Assignment/GetAssignedAssignmentsForCarTransportTruckAssignment`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentQueryKey(
        params
      );

    const assignmentGetAssignedAssignmentsForCarTransportTruckAssignment =
      useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetAssignedAssignmentsForCarTransportTruckAssignment(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook
        >
      >
    >
  >;
export type AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentQueryError =
  unknown;

export const useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignment =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentQueryOptions(
        params,
        options
      );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
  };

export const useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook =
  () => {
    const assignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments =
      useCustomInstance<TransportAssignmentWithSegmentsModel[]>();

    return useCallback(
      (
        params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments(
          {
            url: `/api/Assignment/GetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments`,
            method: 'GET',
            params,
            signal,
          }
        );
      },
      [
        assignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments,
      ]
    );
  };

export const getAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsQueryKey =
  (
    params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsParams
  ) => {
    return [
      `/api/Assignment/GetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsQueryKey(
        params
      );

    const assignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments =
      useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook
        >
      >
    >
  >;
export type AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsQueryError =
  unknown;

export const useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegments =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      useAssignmentGetAssignedAssignmentsForCarTransportTruckAssignmentWithSegmentsQueryOptions(
        params,
        options
      );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
  };

export const useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook =
  () => {
    const assignmentFindAssignableAssignmentsForCarTransportTruckAssignment =
      useCustomInstance<AssignmentViewModel[]>();

    return useCallback(
      (
        params?: AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentParams
      ) => {
        return assignmentFindAssignableAssignmentsForCarTransportTruckAssignment(
          {
            url: `/api/Assignment/FindAssignableAssignmentsForCarTransportTruckAssignment`,
            method: 'POST',
            params,
          }
        );
      },
      [assignmentFindAssignableAssignmentsForCarTransportTruckAssignment]
    );
  };

export const useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentFindAssignableAssignmentsForCarTransportTruckAssignment =
      useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook
          >
        >
      >,
      {
        params?: AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentFindAssignableAssignmentsForCarTransportTruckAssignment(
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook
        >
      >
    >
  >;

export type AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentMutationError =
  unknown;

export const useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignment =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentParams;
      },
      TContext
    >;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentParams;
    },
    TContext
  > => {
    const mutationOptions =
      useAssignmentFindAssignableAssignmentsForCarTransportTruckAssignmentMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };
export const useAssignmentGetTransportAssignmentModelsForAssignmentHook =
  () => {
    const assignmentGetTransportAssignmentModelsForAssignment =
      useCustomInstance<TransportAssignmentModel[]>();

    return useCallback(
      (
        params?: AssignmentGetTransportAssignmentModelsForAssignmentParams,
        signal?: AbortSignal
      ) => {
        return assignmentGetTransportAssignmentModelsForAssignment({
          url: `/api/Assignment/GetTransportAssignmentModelsForAssignment`,
          method: 'GET',
          params,
          signal,
        });
      },
      [assignmentGetTransportAssignmentModelsForAssignment]
    );
  };

export const getAssignmentGetTransportAssignmentModelsForAssignmentQueryKey = (
  params?: AssignmentGetTransportAssignmentModelsForAssignmentParams
) => {
  return [
    `/api/Assignment/GetTransportAssignmentModelsForAssignment`,
    ...(params ? [params] : []),
  ] as const;
};

export const useAssignmentGetTransportAssignmentModelsForAssignmentQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetTransportAssignmentModelsForAssignmentHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: AssignmentGetTransportAssignmentModelsForAssignmentParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useAssignmentGetTransportAssignmentModelsForAssignmentHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getAssignmentGetTransportAssignmentModelsForAssignmentQueryKey(params);

    const assignmentGetTransportAssignmentModelsForAssignment =
      useAssignmentGetTransportAssignmentModelsForAssignmentHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetTransportAssignmentModelsForAssignmentHook
          >
        >
      >
    > = ({ signal }) =>
      assignmentGetTransportAssignmentModelsForAssignment(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetTransportAssignmentModelsForAssignmentHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type AssignmentGetTransportAssignmentModelsForAssignmentQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentGetTransportAssignmentModelsForAssignmentHook
        >
      >
    >
  >;
export type AssignmentGetTransportAssignmentModelsForAssignmentQueryError =
  unknown;

export const useAssignmentGetTransportAssignmentModelsForAssignment = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useAssignmentGetTransportAssignmentModelsForAssignmentHook
      >
    >
  >,
  TError = unknown,
>(
  params?: AssignmentGetTransportAssignmentModelsForAssignmentParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentGetTransportAssignmentModelsForAssignmentHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useAssignmentGetTransportAssignmentModelsForAssignmentQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useAssignmentCancelAssignmentHook = () => {
  const assignmentCancelAssignment = useCustomInstance<void>();

  return useCallback(
    (cancelAssignmentRequest: CancelAssignmentRequest) => {
      return assignmentCancelAssignment({
        url: `/api/Assignment/CancelAssignment`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: cancelAssignmentRequest,
      });
    },
    [assignmentCancelAssignment]
  );
};

export const useAssignmentCancelAssignmentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentCancelAssignmentHook>>>,
    TError,
    { data: CancelAssignmentRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAssignmentCancelAssignmentHook>>>,
  TError,
  { data: CancelAssignmentRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentCancelAssignment = useAssignmentCancelAssignmentHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAssignmentCancelAssignmentHook>>>,
    { data: CancelAssignmentRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentCancelAssignment(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentCancelAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAssignmentCancelAssignmentHook>>>
>;
export type AssignmentCancelAssignmentMutationBody = CancelAssignmentRequest;
export type AssignmentCancelAssignmentMutationError = unknown;

export const useAssignmentCancelAssignment = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAssignmentCancelAssignmentHook>>>,
    TError,
    { data: CancelAssignmentRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAssignmentCancelAssignmentHook>>>,
  TError,
  { data: CancelAssignmentRequest },
  TContext
> => {
  const mutationOptions = useAssignmentCancelAssignmentMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook =
  () => {
    const assignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDate =
      useCustomInstance<AssignmentViewModel[]>();

    return useCallback(
      (
        params?: AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateParams
      ) => {
        return assignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDate({
          url: `/api/Assignment/FindUnassignedAssignmentsForUserBetweenZipCodesOnDate`,
          method: 'POST',
          params,
        });
      },
      [assignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDate]
    );
  };

export const useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateParams;
    },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDate =
      useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook
          >
        >
      >,
      {
        params?: AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateParams;
      }
    > = (props) => {
      const { params } = props ?? {};

      return assignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDate(
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook
        >
      >
    >
  >;

export type AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateMutationError =
  unknown;

export const useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDate =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook
          >
        >
      >,
      TError,
      {
        params?: AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateParams;
      },
      TContext
    >;
  }): UseMutationResult<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateHook
        >
      >
    >,
    TError,
    {
      params?: AssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateParams;
    },
    TContext
  > => {
    const mutationOptions =
      useAssignmentFindUnassignedAssignmentsForUserBetweenZipCodesOnDateMutationOptions(
        options
      );

    return useMutation(mutationOptions);
  };
export const useAssignmentValidateUsersForDayTransferHook = () => {
  const assignmentValidateUsersForDayTransfer =
    useCustomInstance<DayTransferValidationResult>();

  return useCallback(
    (
      validateUsersForDayTransferRequest: ValidateUsersForDayTransferRequest
    ) => {
      return assignmentValidateUsersForDayTransfer({
        url: `/api/Assignment/ValidateUsersForDayTransfer`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: validateUsersForDayTransferRequest,
      });
    },
    [assignmentValidateUsersForDayTransfer]
  );
};

export const useAssignmentValidateUsersForDayTransferMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentValidateUsersForDayTransferHook>
      >
    >,
    TError,
    { data: ValidateUsersForDayTransferRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentValidateUsersForDayTransferHook>>
  >,
  TError,
  { data: ValidateUsersForDayTransferRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const assignmentValidateUsersForDayTransfer =
    useAssignmentValidateUsersForDayTransferHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentValidateUsersForDayTransferHook>
      >
    >,
    { data: ValidateUsersForDayTransferRequest }
  > = (props) => {
    const { data } = props ?? {};

    return assignmentValidateUsersForDayTransfer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignmentValidateUsersForDayTransferMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentValidateUsersForDayTransferHook>>
  >
>;
export type AssignmentValidateUsersForDayTransferMutationBody =
  ValidateUsersForDayTransferRequest;
export type AssignmentValidateUsersForDayTransferMutationError = unknown;

export const useAssignmentValidateUsersForDayTransfer = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentValidateUsersForDayTransferHook>
      >
    >,
    TError,
    { data: ValidateUsersForDayTransferRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useAssignmentValidateUsersForDayTransferHook>>
  >,
  TError,
  { data: ValidateUsersForDayTransferRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentValidateUsersForDayTransferMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useAssignmentTransferAllAssignmentsForUserAndDateHook = () => {
  const assignmentTransferAllAssignmentsForUserAndDate =
    useCustomInstance<TransferAssignmentsResult>();

  return useCallback(
    (transferAssignmentsRequest: TransferAssignmentsRequest) => {
      return assignmentTransferAllAssignmentsForUserAndDate({
        url: `/api/Assignment/TransferAllAssignmentsForUserAndDate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: transferAssignmentsRequest,
      });
    },
    [assignmentTransferAllAssignmentsForUserAndDate]
  );
};

export const useAssignmentTransferAllAssignmentsForUserAndDateMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentTransferAllAssignmentsForUserAndDateHook
          >
        >
      >,
      TError,
      { data: TransferAssignmentsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentTransferAllAssignmentsForUserAndDateHook>
      >
    >,
    TError,
    { data: TransferAssignmentsRequest },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const assignmentTransferAllAssignmentsForUserAndDate =
      useAssignmentTransferAllAssignmentsForUserAndDateHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useAssignmentTransferAllAssignmentsForUserAndDateHook
          >
        >
      >,
      { data: TransferAssignmentsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return assignmentTransferAllAssignmentsForUserAndDate(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AssignmentTransferAllAssignmentsForUserAndDateMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentTransferAllAssignmentsForUserAndDateHook>
      >
    >
  >;
export type AssignmentTransferAllAssignmentsForUserAndDateMutationBody =
  TransferAssignmentsRequest;
export type AssignmentTransferAllAssignmentsForUserAndDateMutationError =
  unknown;

export const useAssignmentTransferAllAssignmentsForUserAndDate = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useAssignmentTransferAllAssignmentsForUserAndDateHook>
      >
    >,
    TError,
    { data: TransferAssignmentsRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<typeof useAssignmentTransferAllAssignmentsForUserAndDateHook>
    >
  >,
  TError,
  { data: TransferAssignmentsRequest },
  TContext
> => {
  const mutationOptions =
    useAssignmentTransferAllAssignmentsForUserAndDateMutationOptions(options);

  return useMutation(mutationOptions);
};
